<template>
  <div>
    <div
      class="modal fade"
      id="propertyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="propertyModalLabel"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="propertyModalLabel">{{$helper.getWord('Properties')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="propertyTab" role="tablist">
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="display-tab"
                  data-toggle="tab"
                  href="#display"
                  role="tab"
                  aria-controls="display"
                  aria-selected="true"
                >{{$helper.getWord('Display')}}</a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="data-tab"
                  data-toggle="tab"
                  href="#data"
                  role="tab"
                  aria-controls="data"
                  aria-selected="false"
                >{{$helper.getWord('Data')}}</a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="validation-tab"
                  data-toggle="tab"
                  href="#validation"
                  role="tab"
                  aria-controls="validation"
                  aria-selected="false"
                >{{$helper.getWord('Validation')}}</a>
              </li>

              <!-- <li class="nav-item" role="presentation">
                <a class="nav-link" id="accessRight-tab" data-toggle="tab" href="#accessRight" role="tab"
                  aria-controls="accessRight" aria-selected="false">Access Right</a>
              </li> -->

              <li class="nav-item" role="presentation">
                <a class="nav-link" id="condition-tab" data-toggle="tab" href="#condition" role="tab"
                  aria-controls="condition" aria-selected="false">Conditional</a>
              </li>

              <li class="nav-item" role="presentation">
                <a class="nav-link" id="logic-tab" data-toggle="tab" href="#logic" role="tab"
                  aria-controls="logic" aria-selected="false">Logic</a>
              </li>
            </ul>

            <div class="tab-content" id="propertyTabContent">
              <div
                class="tab-pane fade show active"
                id="display"
                role="tabpanel"
                aria-labelledby="display-tab"
              >
                <div class="row">
                  <label class="col-form-label col-12">{{$helper.getWord('Label')}}</label>
                  <div class="col-12">
                    <input type="text" id="txt_fblabel" class="form-control" />
                  </div>
                  <div class="col-12">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="txt_fbhidelabel" />
                      <label class="form-check-label" for="txt_fbhidelabel">{{$helper.getWord('Hide Label')}}</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="txt_fbreadonly" />
                      <label class="form-check-label" for="txt_fbreadonly">{{$helper.getWord('Read Only')}}</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="txt_fbinvisible" />
                      <label class="form-check-label" for="txt_fbinvisible">{{$helper.getWord('Invisible')}}</label>
                    </div>
                  </div>
                   <div class="col-12">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="txt_fbsubmitcanchange">
                      <label class="form-check-label" for="txt_fbsubmitcanchange">{{$helper.getWord('Submit Can Change')}}</label>
                    </div>
                  </div>

                   <div class="col-12">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="txt_fbsupportmultiplelanguages">
                      <label class="form-check-label" for="txt_fbsupportmultiplelanguages">{{$helper.getWord('SupportLanguages')}}</label>
                    </div>
                  </div>

                  <label class="col-form-label col-12">{{$helper.getWord('Placeholder')}}</label>
                  <div class="col-12">
                    <input type="text" id="txt_fbplaceholder" class="form-control" />
                  </div>
                  <label class="col-form-label col-12">{{$helper.getWord('Description')}}</label>
                  <div class="col-12">
                    <input type="text" id="txt_fbhelptext" class="form-control" />
                  </div>
                  <!-- <label class="col-form-label col-12">Tooltip</label>
                  <div class="col-12">
                    <input type="text" id="txt_fbtooltip" class="form-control">
                  </div>-->
                  <label class="col-form-label col-12">{{$helper.getWord('Model')}}</label>
                  <div class="col-12">
                    <div class="form-group">
                      <select id="txt_fbmodelbuilder" class="custom-select"></select>
                    </div>
                  </div>
                  <label class="col-form-label col-12">{{$helper.getWord('Rows')}}</label>
                  <div class="col-12">
                    <input type="number" id="txt_fbrows" class="form-control" />
                  </div>
                  <label class="col-form-label col-12">{{$helper.getWord('Label Position')}}</label>
                  <div class="col-12">
                    <div class="form-group">
                      <select id="txt_fblabelposition" class="custom-select">
                        <option value="top">{{$helper.getWord('Top')}}</option>
                        <option value="left">{{$helper.getWord('Left')}}</option>
                        <option value="right">{{$helper.getWord('Right')}}</option>
                        <option value="center">{{$helper.getWord('Center')}}</option>
                      </select>
                    </div>
                  </div>
                  <!-- <label class="col-form-label col-12">Decimal Places</label>
                  <div class="col-12">
                    <input type="number" id="txt_fbdecimal_places" class="form-control" placeholder="2" value="2"/>
                  </div> -->
                </div>
              </div>
              <div class="tab-pane fade" id="data" role="tabpanel" aria-labelledby="data-tab">
                <div class="row">
                  <label class="col-form-label col-12" id="defaultValueLabel">{{$helper.getWord('Default Value')}}</label>
                  <div class="col-12">
                    <input type="text" id="txt_fbdefaultvalue" class="form-control" />
                  </div>
                  <div id="txt_fbselect" class="col-sm-12">
                    <label class="col-form-label col-12">{{$helper.getWord('Select Values')}}</label>
                    <div class="row select">
                      <div class="col-12">
                        <table class="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col">{{$helper.getWord('Label2')}}</th>
                              <th scope="col">{{$helper.getWord('Value')}}</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody></tbody>
                        </table>
                        <button class="btn btn-primary" id="addValue">{{$helper.getWord('Add Value')}}</button>
                      </div>
                    </div>
                  </div>

                  <label class="col-form-label col-12">{{$helper.getWord('Text Case')}}</label>
                  <div id="txt_fbtextcase" class="col-sm-12">
                    <select class="form-control">
                      <option></option>
                      <option value="mixed">{{$helper.getWord('Mixed')}} ({{$helper.getWord('Uppercase')}}{{$helper.getWord('or')}}{{$helper.getWord('Lowercase')}})</option>
                      <option value="uppercase">{{$helper.getWord('Uppercase')}}</option>
                      <option value="lowercase">{{$helper.getWord('Lowercase')}}</option>
                    </select>
                  </div>

                  <label class="col-form-label col-12">{{$helper.getWord('Type')}}</label>
                  <div id="txt_fbtype" class="col-sm-12">
                    <select class="form-control">
                      <!-- <option value="count">Count</option>
                      <option value="amount">Amount</option>-->
                    </select>
                  </div>

                  <label class="col-form-label col-12">{{$helper.getWord('Corresponding Table')}} / {{$helper.getWord('Column')}}</label>
                  <div id="txt_fbspecificcolumn" class="col-sm-12">
                    <div class="form-group">
                      <!-- JS HANDLE -->
                    </div>
                  </div>

                  <label class="col-form-label col-12">Type 2</label>
                  <div id="txt_fbtype2" class="col-sm-12">
                    <select class="form-control">
                      <!-- <option value="count">Count</option>
                      <option value="amount">Amount</option>-->
                    </select>
                  </div>

                  <label class="col-form-label col-12">{{$helper.getWord('Corresponding Table')}} / {{$helper.getWord('Column')}} 2</label>
                  <div id="txt_fbspecificcolumn2" class="col-sm-12">
                    <div class="form-group">
                      <!-- JS HANDLE -->
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="validation" role="tabpanel" aria-labelledby="validation-tab">
                <div class="col-12">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="txt_fbrequired" />
                    <label class="form-check-label" for="txt_fbrequired">{{$helper.getWord('Required Fill In')}}</label>
                  </div>
                </div>

                <label class="col-form-label col-12">{{$helper.getWord('Minimum Length')}}</label>
                <div class="col-12">
                  <input type="text" id="txt_fbminlength" class="form-control" />
                </div>

                <label class="col-form-label col-12">{{$helper.getWord('Maximum Length')}}</label>
                <div class="col-12">
                  <input type="text" id="txt_fbmaxlength" class="form-control" />
                </div>

                <label class="col-form-label col-12" title="https://github.com/RobinHerbots/Inputmask">{{$helper.getWord('Input Mask')}}</label>
                <div class="col-12">
                  <input type="text" id="txt_fbinputmask" class="form-control" placeholder="9: numeric, a: alphabetical, *: alphanumeric">
                </div>               
              </div>

              <div class="tab-pane fade"  id="accessRight"  role="tabpanel"  aria-labelledby="accessRight-tab">
                <div class="col-12">
                  <label class="col-form-label">{{$helper.getWord('Role')}}</label>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="role1" />
                    <label class="form-check-label">{{$helper.getWord('Role')}}1</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="role2" />
                    <label class="form-check-label">{{$helper.getWord('Role')}}2</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="role3" />
                    <label class="form-check-label">{{$helper.getWord('Role')}}3</label>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade"  id="condition"  role="tabpanel"  aria-labelledby="condition-tab">
                <label class="col-form-label col-12">{{$helper.getWord('ThiscomponentDisplay')}}:</label>
                <div id="txt_fbcondition_display" class="col-sm-12">
                  <select class="form-control">
                    <option value=""></option>
                    <option value="true">{{$helper.getWord('True')}}</option>
                    <option value="false">{{$helper.getWord('False')}}</option>
                  </select>
                </div>

                <label class="col-form-label col-12">{{$helper.getWord('WhenFormComponent')}}:</label>
                <div id="txt_fbcondition_from" class="col-sm-12">
                  <select class="form-control">
                    <!-- JS HANDLE -->
                  </select>
                </div>

                <label class="col-form-label col-12">Has the Value:</label>
                <div class="col-12">
                  <input type="text" id="txt_fbcondition_value" class="form-control" />
                </div>
              </div>

              <div class="tab-pane fade"  id="logic"  role="tabpanel"  aria-labelledby="logic-tab">
                TODO: Javascript Text Field setting
                <!-- JAVASCRIPT  -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              id="btn_propertyConfirm"
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >{{$helper.getWord('Save')}}</button>
            <button type="button" class="btn" data-dismiss="modal">{{$helper.getWord('Cancel')}}</button>
          </div>
        </div>
      </div>
    </div>
    <button @click="$helper.setFormBuilderMenu(false)" class="btn btn-danger navbar-btn">
      <i class="fas fa-chevron-left"></i> {{$helper.getWord('BACK')}}
    </button>
    <div class="sidebar-nav" style="overflow-y: scroll;">
      <ul class="nav nav-list accordion-group" style="overflow-y: hidden;overflow-x: hidden;">
        <li class="nav-header">
          <i class="fas fa-plus"></i> {{$helper.getWord('Layout Design')}}
        </li>
        <li style="display: list-item; width: 500px;" class="rows">
          <div class="fbrow ui-draggable">
            <a href="#close" class="remove btn btn-danger btn-sm">
              <i class="fas fa-minus-circle icon-white"></i>Remove
            </a>
            <span class="drag btn btn-info btn-sm">
              <i class="fas fa-arrows-alt"></i>Drag
            </span>
            <div class="preview col-sm-8">{{$helper.getWord('One Column')}}</div>
            <div class="view">
              <div class="row clearfix">
                <div class="col-12 column"></div>
              </div>
            </div>
          </div>
          <div class="fbrow ui-draggable">
            <a href="#close" class="remove btn btn-danger btn-sm">
              <i class="fas fa-minus-circle icon-white"></i>Remove
            </a>
            <span class="drag btn btn-info btn-sm">
              <i class="fas fa-arrows-alt"></i>Drag
            </span>
            <div class="preview col-sm-8">{{$helper.getWord('Two Columns')}}</div>
            <div class="view">
              <div class="row clearfix">
                <div class="col-sm-6 column"></div>
                <div class="col-sm-6 column"></div>
              </div>
            </div>
          </div>
          <div class="fbrow ui-draggable">
            <a href="#close" class="remove btn btn-danger btn-sm">
              <i class="fas fa-minus-circle icon-white"></i>Remove
            </a>
            <span class="drag btn btn-info btn-sm">
              <i class="fas fa-arrows-alt"></i>Drag
            </span>
            <div class="preview col-sm-8">{{$helper.getWord('Three Columns')}}</div>
            <div class="view">
              <div class="row clearfix">
                <div class="col-sm-4 column"></div>
                <div class="col-sm-4 column"></div>
                <div class="col-sm-4 column"></div>
              </div>
            </div>
          </div>
          <div class="fbrow ui-draggable">
            <a href="#close" class="remove btn btn-danger btn-sm">
              <i class="fas fa-minus-circle icon-white"></i>Remove
            </a>
            <span class="drag btn btn-info btn-sm">
              <i class="fas fa-arrows-alt"></i>Drag
            </span>
            <div class="preview col-sm-8">{{$helper.getWord('Four entities')}}</div>
            <div class="view">
              <div class="row clearfix">
                <div class="col-12 column">
                  <div class="row clearfix">
                    <div class="col-sm-6 column"></div>
                    <div class="col-sm-6 column"></div>
                  </div>
                  <div class="row clearfix">
                    <div class="col-sm-6 column"></div>
                    <div class="col-sm-6 column"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fbrow ui-draggable">
            <a href="#close" class="remove btn btn-danger btn-sm">
              <i class="fas fa-minus-circle icon-white"></i>Remove
            </a>
            <span class="drag btn btn-info btn-sm">
              <i class="fas fa-arrows-alt"></i>Drag
            </span>
            <div class="preview col-sm-8">{{$helper.getWord('Six entities')}}</div>
            <div class="view">
              <div class="row clearfix">
                <div class="col-12 column">
                  <div class="row clearfix">
                    <div class="col-sm-6 column"></div>
                    <div class="col-sm-6 column"></div>
                  </div>
                  <div class="row clearfix">
                    <div class="col-sm-6 column"></div>
                    <div class="col-sm-6 column"></div>
                  </div>
                  <div class="row clearfix">
                    <div class="col-sm-6 column"></div>
                    <div class="col-sm-6 column"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <ul class="nav nav-list accordion-group" style="overflow-y: hidden;overflow-x: hidden;">
        <li class="nav-header">
          <i class="fas fa-plus"></i> {{$helper.getWord('Components')}}
        </li>
        <li class="rows components" style="width: 500px;">
          <!-- JS HANDLE -->
        </li>
      </ul>

      <ul class="nav nav-list accordion-group" style="overflow-y: hidden;overflow-x: hidden;">
        <li class="nav-header">
          <i class="fas fa-plus"></i> {{$helper.getWord('Model')}}
        </li>
        <li style="width: 500px;" class="rows modelBuilder">
          <!-- JS HANDLE -->
        </li>
      </ul>
    </div>
  </div>
</template>

<style>
.link-span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 980px) {
  /* Enable use of floated navbar text */
  .navbar-text.pull-right {
    float: none;
    padding-left: 5px;
    padding-right: 5px;
  }
}

@media (max-width: 979px) {
  .navbar-fixed-top {
    position: fixed;
  }
}

.navbar-inverse .brand {
  width: 180px;
  color: #fff;
}

.brand img {
  float: left;
  margin: 2px 10px 0 0;
}

.brand .label {
  position: relative;
  left: 10px;
  top: -3px;
  font-weight: normal;
  font-size: 9px;
  background: #666;
  -webkit-box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.7);
  -moz-box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.7);
  box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.7);
}

.edit .fbcontainer {
  margin-left: -30px;
  margin-right: -30px;

  padding: 100px 15px 15px;
  border-radius: 4px;
  position: relative;
  word-wrap: break-word;
  width: 100%;
}

.edit .fbcontainer:after {
  background-color: #f5f5f5;
  border: 1px solid #dddddd;
  border-radius: 4px 0 4px 0;
  color: #9da0a4;
  content: "Container";
  font-size: 12px;
  font-weight: bold;
  left: -1px;
  padding: 3px 7px;
  position: absolute;
  top: -1px;
}

.sidebar-nav {
  /* position: fixed;
  width: 210px;
  left: 0px;
  bottom: 0;
  top: 44px;
  background: #464646;
  padding: 9px 0;
  z-index: 10;
  overflow: auto;
  -webkit-transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
  transition: all 500ms ease; */
  background: #fff;
}

.sidebar-nav .nav-header {
  cursor: pointer;
  font-size: 14px;
  color: #78828a;
}

.sidebar-nav .nav-header span.label {
  font-size: 10px;
  /*padding-bottom:0;*/
  position: relative;
  top: -1px;
}

.sidebar-nav .nav-header .popover {
  color: #999;
  text-shadow: none;
}

.popover-info {
  position: relative;
}

.popover-info .popover {
  display: none;
  top: -12.5px;
  left: 15px;
}

.popover-info:hover .popover {
  display: block;
  opacity: 1;
  width: 400px;
}

.popover-info:hover .popover .arrow {
  top: 23px;
}

.sidebar-nav .accordion-group {
  border: none;
}

.sidebar-nav li {
  line-height: 25px;
}

.sidebar-nav .box {
  line-height: 25px;
  width: 170px;
  height: 25px;
}

.sidebar-nav .preview {
  display: block;
  color: #78828a;
  /* font-size: 12px; */
  font-size: 1em;
  line-height: 22px;
  padding: 4px 0 8px 0;
}

.sidebar-nav .preview input {
  width: 105px;
  padding: 0 10px;
  font-size: 10px;
  line-height: 20px;
  height: 20px;
  position: relative;
  top: -1px;
  border: 0;
}

.sidebar-nav .boxes {
  display: none;
}

.fbcontainer .preview {
  display: none;
}

.fbcontainer .box .view {
  display: block;
  padding-top: 30px;
}

.ui-draggable-dragging .view {
  display: block;
}

.ui-sortable-placeholder {
  outline: 2px dashed #ddd;
  visibility: visible;
  border-radius: 4px;
  height: 143px;
  margin: 8px;
}

.edit .drag {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.box,
.fbrow {
  position: relative;
}

.edit .fbcontainer .fbrow .drag {
  top: 5px;
  /* updated by Alan Chow */
  /* right: 80px; */
  right: 88px;
  z-index: 10;
}

.edit .fbcontainer .column .box .drag {
  top: 5px;
}

.edit .fbcontainer .column .box .configuration {
  position: absolute;
  /* top: -15px; */
  top: -20px;
  /* right: 140px; */
  right: 0px;
  white-space: nowrap;
}

.edit .fbcontainer .remove {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;
  color: #fff;
}

.fbcontainer .configuration {
  filter: alpha(opacity=0);
  opacity: 0;
  -webkit-transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
  transition: all 500ms ease;
}

.fbcontainer .drag,
.fbcontainer .remove {
  filter: alpha(opacity=20);
  opacity: 0.2;
  -webkit-transition: all 500ms ease;
  -moz-transition: all 500ms ease;
  -ms-transition: all 500ms ease;
  -o-transition: all 500ms ease;
  transition: all 500ms ease;
}

.fbcontainer .fbrow:hover > .drag,
.fbcontainer .fbrow:hover > .configuration,
.fbcontainer .fbrow:hover > .remove,
.fbcontainer .box:hover .drag,
.fbcontainer .box:hover .configuration,
.fbcontainer .box:hover .remove {
  filter: alpha(opacity=100);
  opacity: 1;
}

.edit .fbcontainer .row:before {
  /* background-color: #f5f5f5; */
  border: 1px solid #dddddd;
  border-radius: 4px 0 4px 0;
  color: #9da0a4;
  content: "Row";
  font-size: 12px;
  font-weight: bold;
  left: -1px;
  line-height: 2;
  padding: 3px 7px;
  position: absolute;
  top: -1px;
}

.edit .fbcontainer .row,
.devpreview .fbcontainer .row {
  background-color: #f5f5f5;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: inset 0 1px 13px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: inset 0 1px 13px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 13px rgba(0, 0, 0, 0.1);
  border: 1px solid #dddddd;
  border-radius: 4px 4px 4px 4px;
  margin: 15px 0;
  position: relative;
  padding: 25px 14px 20px;
}

/* updated by Alan Chow */
.edit .fbcontainer .row.noshow:before {
  /* background-color: #f5f5f5; */
  border: none;
  border-radius: 0;
  content: "";
  font-size: 12px;
  font-weight: bold;
  left: -1px;
  line-height: 2;
  padding: 0;
  position: absolute;
  top: -1px;
}
.edit .fbcontainer .row.textinput:before {
  content: "TextInput";
}
.edit .fbcontainer .row.dateinput:before {
  content: "DateInput";
}
.edit .fbcontainer .row.datetimeinput:before {
  content: "DateTimeInput";
}
.edit .fbcontainer .row.textareainput:before {
  content: "TextAreaInput";
}
.edit .fbcontainer .row.numberinput:before {
  content: "NumberInput";
}
.edit .fbcontainer .row.select:before {
  content: "SelectBox";
}
.edit .fbcontainer .row.radio:before {
  content: "Radio";
}
.edit .fbcontainer .row.checkbox:before {
  content: "Check Box";
}
.edit .fbcontainer .row.checkboxes:before {
content: "Check Boxes";
}
.edit .fbcontainer .row.fileupload:before {
  content: "File Upload";
}

.edit .fbcontainer .row.fbinput,
.fbcontainer .devpreview .row.fbinput {
  background-color: #ffffff;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: 1px solid #dddddd;
  border-radius: 4px 4px 4px 4px;
  margin: 15px 0;
  position: relative;
  padding: 25px 14px 14px;
}
.edit .fbcontainer .row.noshow {
  background-color: transparent;
  -webkit-box-sizing: none;
  -moz-box-sizing: none;
  box-sizing: none;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  margin: -15px -15px;
}

.edit .fbcontainer .fbDetailTable:before {
  background-color: #f5f5f5;
  border: 1px solid #dddddd;
  border-radius: 4px 0 4px 0;
  color: #9da0a4;
  content: "Detail Table";
  font-size: 12px;
  font-weight: bold;
  left: -1px;
  line-height: 2;
  padding: 3px 7px;
  position: absolute;
  top: -1px;
}

.edit .fbcontainer .fbPanel:before {
  background-color: #f5f5f5;
  border: 1px solid #dddddd;
  border-radius: 4px 0 4px 0;
  color: #9da0a4;
  content: "Panel";
  font-size: 12px;
  font-weight: bold;
  left: -1px;
  line-height: 2;
  padding: 3px 7px;
  position: absolute;
  top: -1px;
}
/* end update */

.edit .fbcontainer .column:after {
  background-color: #f5f5f5;
  border: 1px solid #dddddd;
  border-radius: 4px 0 4px 0;
  color: #9da0a4;
  content: "Column";
  font-size: 12px;
  font-weight: bold;
  left: -1px;
  padding: 3px 7px;
  position: absolute;
  top: -1px;
}

.edit .fbcontainer .column,
.devpreview .column {
  background-color: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 4px 4px 4px 4px;
  margin: 15px 0;
  padding: 39px 19px 24px;
  position: relative;
}

/* preview */
/* body.devpreview {
  margin-left: 0px; } */

.devpreview .sidebar-nav {
  left: -210px;
  -webkit-transition: all 0ms ease;
  -moz-transition: all 0ms ease;
  -ms-transition: all 0ms ease;
  -o-transition: all 0ms ease;
  transition: all 0ms ease;
}

.devpreview .drag,
.devpreview .configuration,
.devpreview .remove {
  display: inline-block;
}

/* updated by Alan Chow */
.sourcepreview .drag,
.sourcepreview .configuration,
.sourcepreview .remove {
  display: none;
}

/* .sourcepreview .column, .sourcepreview .row, .sourcepreview .fbcontainer .box {
  margin: 0px 0; /* Alan: this remove the default .row -15  */
/* margin-top: 0px;
  margin-bottom: 0px; 
  padding: 0px;
  background: none;
  border: none;
  -webkit-box-shadow: inset 0 0px 0px transparent;
  -moz-box-shadow: inset 0 0px 0px transparent;
  box-shadow: inset 0 0px 0px transparent; } */

.devpreview .fbcontainer .box,
.devpreview .fbcontainer .row {
  padding-top: 0;
  background: none;
}

.devpreview .fbcontainer .column {
  padding-top: 19px;
  padding-bottom: 19px;
}

#download-layout {
  display: none;
}

#editorModal textarea,
#downloadModal textarea {
  width: 100%;
  height: 280px;
  resize: none;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  min-height: 30px;
}

a.language-selected {
  font-style: italic;
  font-weight: bold;
}

.fbsidebar .sidebar-nav .view {
  display: none;
}

.fbsidebar .sidebar-nav .remove,
.fbsidebar .sidebar-nav .configuration {
  display: none;
}

.fbsidebar .accordion {
  margin-bottom: 20px;
}

.fbsidebar .accordion-group {
  margin-bottom: 2px;
}

.fbsidebar .accordion-heading {
  border-bottom: 0;
}

.fbsidebar .accordion-heading .accordion-toggle {
  display: block;
  padding: 8px 15px;
}

.fbsidebar .accordion-toggle {
  cursor: pointer;
}

.fbsidebar .accordion-inner {
  padding: 9px 15px;
  border-top: 1px solid #e5e5e5;
}

.fbsidebar .nav {
  margin-left: 0;
  margin-bottom: 20px;
  list-style: none;
}

.fbsidebar .nav > li > a {
  display: block;
}

.fbsidebar .nav > li > a:hover,
.fbsidebar .nav > li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}

.fbsidebar .nav > li > a > img {
  max-width: none;
}

.fbsidebar .nav > .pull-right {
  float: right;
}

.fbsidebar .nav-header {
  display: block;
  padding: 3px 15px;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  color: #78828a;
  text-transform: uppercase;
  width: 500px;
}

.fbsidebar .nav li + .nav-header {
  margin-top: 9px;
}

.fbsidebar .nav-list {
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 0;
}

.fbsidebar .nav-list > li > a,
.fbsidebar .nav-list .nav-header {
  margin-left: -15px;
  margin-right: -15px;
}

.fbsidebar .nav-list > li > a {
  padding: 3px 15px;
}

.fbsidebar .nav-list > .active > a,
.fbsidebar .nav-list > .active > a:hover,
.fbsidebar .nav-list > .active > a:focus {
  color: #ffffff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2);
  background-color: #0088cc;
}

.fbsidebar .nav-list [class^="icon-"],
.fbsidebar .nav-list [class*=" icon-"] {
  margin-right: 2px;
}

.fbsidebar .nav-list .divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  background-color: #e5e5e5;
  border-bottom: 1px solid #ffffff;
}

.fbsidebar .nav-tabs,
.fbsidebar .nav-pills {
  *zoom: 1;
}

.fbsidebar .nav-tabs:before,
.fbsidebar .nav-pills:before,
.fbsidebar .nav-tabs:after,
.fbsidebar .nav-pills:after {
  display: table;
  content: "";
  line-height: 0;
}

.fbsidebar .nav-tabs:after,
.fbsidebar .nav-pills:after {
  clear: both;
}

.fbsidebar .nav-tabs > li,
.fbsidebar .nav-pills > li {
  float: left;
}

.fbsidebar .nav-tabs > li > a,
.fbsidebar .nav-pills > li > a {
  padding-right: 12px;
  padding-left: 12px;
  margin-right: 2px;
  line-height: 14px;
}

.fbsidebar .nav-tabs {
  border-bottom: 1px solid #ddd;
}

.fbsidebar .nav-tabs > li {
  margin-bottom: -1px;
}

.fbsidebar .nav-tabs > li > a {
  padding-top: 8px;
  padding-bottom: 8px;
  line-height: 20px;
  border: 1px solid transparent;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.fbsidebar .nav-tabs > li > a:hover,
.fbsidebar .nav-tabs > li > a:focus {
  border-color: #eeeeee #eeeeee #dddddd;
}

.fbsidebar .nav-tabs > .active > a,
.fbsidebar .nav-tabs > .active > a:hover,
.fbsidebar .nav-tabs > .active > a:focus {
  color: #555555;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-bottom-color: transparent;
  cursor: default;
}

.fbsidebar .nav-pills > li > a {
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 2px;
  margin-bottom: 2px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.fbsidebar .nav-pills > .active > a,
.fbsidebar .nav-pills > .active > a:hover,
.fbsidebar .nav-pills > .active > a:focus {
  color: #ffffff;
  background-color: #0088cc;
}

.fbsidebar .nav-stacked > li {
  float: none;
}

.fbsidebar .nav-stacked > li > a {
  margin-right: 0;
}

.fbsidebar .nav-tabs.nav-stacked {
  border-bottom: 0;
}

.fbsidebar .nav-tabs.nav-stacked > li > a {
  border: 1px solid #ddd;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}

.fbsidebar .nav-tabs.nav-stacked > li:first-child > a {
  -webkit-border-top-right-radius: 4px;
  -moz-border-radius-topright: 4px;
  border-top-right-radius: 4px;
  -webkit-border-top-left-radius: 4px;
  -moz-border-radius-topleft: 4px;
  border-top-left-radius: 4px;
}

.fbsidebar .nav-tabs.nav-stacked > li:last-child > a {
  -webkit-border-bottom-right-radius: 4px;
  -moz-border-radius-bottomright: 4px;
  border-bottom-right-radius: 4px;
  -webkit-border-bottom-left-radius: 4px;
  -moz-border-radius-bottomleft: 4px;
  border-bottom-left-radius: 4px;
}

.fbsidebar .nav-tabs.nav-stacked > li > a:hover,
.fbsidebar .nav-tabs.nav-stacked > li > a:focus {
  border-color: #ddd;
  z-index: 2;
}

.fbsidebar .nav-pills.nav-stacked > li > a {
  margin-bottom: 3px;
}

.fbsidebar .nav-pills.nav-stacked > li:last-child > a {
  margin-bottom: 1px;
}

.fbsidebar .nav-tabs .dropdown-menu {
  -webkit-border-radius: 0 0 6px 6px;
  -moz-border-radius: 0 0 6px 6px;
  border-radius: 0 0 6px 6px;
}

.fbsidebar .nav-pills .dropdown-menu {
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}

.fbsidebar .nav .dropdown-toggle .caret {
  border-top-color: #0088cc;
  border-bottom-color: #0088cc;
  margin-top: 6px;
}

.fbsidebar .nav .dropdown-toggle:hover .caret,
.fbsidebar .nav .dropdown-toggle:focus .caret {
  border-top-color: #005580;
  border-bottom-color: #005580;
}

.fbsidebar .nav-tabs .dropdown-toggle .caret {
  margin-top: 8px;
}

.fbsidebar .nav .active .dropdown-toggle .caret {
  border-top-color: #fff;
  border-bottom-color: #fff;
}

.fbsidebar .nav-tabs .active .dropdown-toggle .caret {
  border-top-color: #555555;
  border-bottom-color: #555555;
}

.fbsidebar .nav > .dropdown.active > a:hover,
.fbsidebar .nav > .dropdown.active > a:focus {
  cursor: pointer;
}

.fbsidebar .nav-tabs .open .dropdown-toggle,
.fbsidebar .nav-pills .open .dropdown-toggle,
.fbsidebar .nav > li.dropdown.open.active > a:hover,
.fbsidebar .nav > li.dropdown.open.active > a:focus {
  color: #ffffff;
  background-color: #999999;
  border-color: #999999;
}

.fbsidebar .nav li.dropdown.open .caret,
.fbsidebar .nav li.dropdown.open.active .caret,
.fbsidebar .nav li.dropdown.open a:hover .caret,
.fbsidebar .nav li.dropdown.open a:focus .caret {
  border-top-color: #ffffff;
  border-bottom-color: #ffffff;
  opacity: 1;
  filter: alpha(opacity=100);
}

.fbsidebar .label {
  display: inline-block;
  padding: 2px 4px;
  font-size: 11.844px;
  font-weight: bold;
  line-height: 14px;
  color: #ffffff;
  vertical-align: baseline;
  white-space: nowrap;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  background-color: #999999;
}

.fbsidebar .label:empty,
.fbsidebar .badge:empty {
  display: none;
}

.fbsidebar a.label:hover,
.fbsidebar a.label:focus,
.fbsidebar a.badge:hover,
.fbsidebar a.badge:focus {
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}

.fbsidebar .label-important,
.fbsidebar .badge-important {
  background-color: #b94a48;
  color: #fff;
}

.fbsidebar .label-important[href],
.fbsidebar .badge-important[href] {
  background-color: #953b39;
}

.fbsidebar .label-warning,
.fbsidebar .badge-warning {
  background-color: #f89406;
}

.fbsidebar .label-warning[href],
.fbsidebar .badge-warning[href] {
  background-color: #c67605;
}

.fbsidebar .label-success,
.fbsidebar .badge-success {
  background-color: #468847;
}

.fbsidebar .label-success[href],
.fbsidebar .badge-success[href] {
  background-color: #356635;
}

.fbsidebar .label-info,
.fbsidebar .badge-info {
  background-color: #3a87ad;
}

.fbsidebar .label-info[href],
.fbsidebar .badge-info[href] {
  background-color: #2d6987;
}

.fbsidebar .label-inverse,
.fbsidebar .badge-inverse {
  background-color: #333333;
}

.fbsidebar .label-inverse[href],
.fbsidebar .badge-inverse[href] {
  background-color: #1a1a1a;
}

.fbsidebar .btn .label,
.fbsidebar .btn .badge {
  position: relative;
  top: -1px;
}

.fbsidebar .btn-mini [class^="icon-"],
.fbsidebar .btn-mini [class*=" icon-"] {
  margin-top: -1px;
}

.fbsidebar .btn-mini {
  padding: 0 6px;
  font-size: 10.5px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

#MD {
  width: 992px;
}

#SM {
  width: 768px;
}

#XS {
  width: 480px;
}

#LG {
  width: 100%;
}
.toolbox-reset .show {
  display: inline-block !important;
}

.toolbox-reset .nav-list {
  padding-left: 15px !important;
  padding-right: 5px !important;
  margin-bottom: 0 !important;
}

/* .sidebar-nav {
      width: 221px !important;
    } */

.custom-control-input {
  position: relative;
  z-index: 99999;
  opacity: 0;
}

.toolbox-reset .custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 5px;
}

.toolbox-reset .custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: -0.5rem;
}

.toolbox-reset .input-group-prepend {
  margin-right: -1px;
  flex-wrap: inherit;
}

.toolbox-reset .form-inline .input-group {
  display: flex;
  vertical-align: middle;
}

.toolbox-reset .input-group {
  flex-wrap: unset;
}

.toolbox-reset .input-group {
  position: relative;
  display: inline-flex;
  border-collapse: separate;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

button,
input {
  overflow: visible;
}

button,
input,
optgroup,
select,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  /* line-height: inherit; */
}

.toolbox-reset label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  /* padding-left: 20px; */
  min-width: 24px;
  font-weight: bold;
}

#label-intermediate-checkbox {
  padding-left: 0px;
}

.sidebar-nav::-webkit-scrollbar {
  display: none;
}

.sidebar-nav {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

#propertyModal ::-webkit-scrollbar {
  display: none;
  padding-top: 50%;
}

#propertyModal {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

#propertyModal {
  z-index: 99999;
  top:15%;
}

#propertyModal .modal-content{
  background: white;
}

.configuration .btn{
  z-index: 10;
  margin-top:10px;
}
</style>



<script>
import config from "@/config"
import api from "@/api"
import helper from "@/vueHelper"

export default {
  props:{
    
  },
  data(){
    return {
      recaptcha_image: "https://developers.google.com/recaptcha/images/newCaptchaAnchor.gif"
    }

  },
  updated() {
    this.init();
  },
  mounted(){
    this.init();
  },
  methods: {
    //WARNING!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    //Cannot Detail Table inside another Detail Table
    //WAENING!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    /******************************Edit Sequence Reminder****************************** */
    /*************1. temporarySave() New Changes*************************************** */
    /*************2. openModal() save the new changes into temporarily XML tag********* */
    /*************3. toggleFbType() *************************************************** */
    /*************4. Finally Save to server (Form/Form/FormBuilder/saveForm())********* */
    /********************************************************************************** */

    init() {
      try {
        this.getModel();
        //this.loadForm();
        this.setComponents();
        this.removeElement();
        this.setDraggable();
        this.openModal();
        this.temporarySave();
        this.addSelectValue();
        this.toggleFbType();
        this.setMaximum();
      } catch (error) {
        console.error(error);
      }
    },
    setDraggable() {
      $('.fbcontainer, .fbcontainer .column').sortable({ //FOR loadForm component's drag and drop
        opacity: 0.35,
        cursorAt: { top: 15, left: 100},
        placeholder: "ui-state-highlight",
        snapTolerance: 5,
		    snapMode: 'outer',
        handle: ".drag",
        cancel: ".noDrag",
        tolerance: "touch",
        connectWith: ".column, .fbcontainer",
        start: function(e, t){
          t.helper.width(300).height(50).css("overflow", "hidden")  
        }
      });

      $('.sidebar-nav .fbrow').draggable({ //For sidebar component's drag and drop
        opacity: 0.35,
        cursorAt: { top: 15, left: 100},
        placeholder: "ui-state-highlight",
        handle: ".drag",
        cancel: ".noDrag",
        tolerance: "touch",
        snapTolerance: 5,
		    snapMode: 'outer',
        connectToSortable: ".column, .fbcontainer",
        appendTo: "body",
        helper: "clone",
        zindex: 99999999,
        start: function(e, t){
          t.helper.width(300).height(50).css("overflow", "hidden")
        },
        stop: function(e, t){
          t.helper.width("auto").height("auto");
          $( ".ui-draggable" ).not( t.helper.css( "z-index", "1" ) ).css( "z-index", "0" ); //JQUERY UI LIBRARY BUG FIX, seems work(?) :D

          $(".fbcontainer .column").sortable({ //For sidebar component's drag and drop after first drop
            opacity: .35,
            connectWith: ".fbcontainer, .column",
            tolerance: 'touch',
            cursorAt: { top: 15, left:100 },
            cancel: '.noDrag',
            snapTolerance: 5,
		        snapMode: 'outer',
            helper: 'original',  //NO idea why must clone
            placeholder: "ui-state-highlight",
            handle: ".drag",
            appendTo: 'body',
            start: function (e, t) {
              t.helper.width(300).height(50).css('overflow', 'hidden');
            }
          });
        }
      });
    },
    removeElement() {
      var $vm = this;
      $(".fbcontainer").delegate(".remove", "click", function(e) {
        e.preventDefault();
        $(this)
          .parent()
          .remove();
        if (!$(".fbcontainer .fbrow").length > 0) {
          $vm.clearContainer();
        }
      });
    },
    clearContainer() {
      $(".fbcontainer").empty();
      // layouthistory = null;
      // if (supportstorage()) localStorage.removeItem("layoutdata");
    },
    getNumberInput(display_name,column_name,datatype,table_name,column_id,table_id,table_type,length) {
      return `<div class="fbrow ui-draggable">
        <a href="#close" class="remove btn btn-danger btn-sm"><i
          class="fas fa-minus-circle icon-white"></i>Remove</a>
        <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
        <span class="configuration">
          <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
          data-target="#propertyModal" modelType="numberInput"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
          <formeditor modelType="numberInput" fblabel="${display_name}" mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fbv-model="formData.${table_name}.${column_name}" fbmaxlength="${length}" fb:isedit="isEdit" fb:approvaledit="approvalEdit" hidden></formeditor>
        </span>
        <div class="preview col-sm-8 modelBuilderName" modeltype='${datatype}' id='${column_name}'>
        ${display_name}
        </div>
        <div class="view">
          <div class="row fbinput numberinput" fbv-if="fb.edit">
          <label class="noDrag col-form-label col-12">${display_name}</label>
          <div class="col-12">
            <input type="number" class="form-control netGroup noDrag datepicker userinput" step="0.01">
          </div>
          <div class="description">

          </div>
          </div>
          <div class="fbResult row" fbv-if="fb.edit == false" hidden>
          <fbnumberbox mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fbmaxlength="${length}" fb:isedit="isEdit" fb:approvaledit="approvalEdit" class="col-sm-12"  />
          </div>
        </div>
        </div>`;
    },
    getTextInput(display_name,column_name,datatype,table_name,column_id,table_id,table_type,length) {
      return `<div class="fbrow ui-draggable">
        <a href="#close" class="remove btn btn-danger btn-sm"><i
          class="fas fa-minus-circle icon-white"></i>Remove</a>
        <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
        <span class="configuration">
          <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
          data-target="#propertyModal" modelType="textInput"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
          <formeditor modelType="textInput" fblabel="${display_name}" mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fbv-model="formData.${table_name}.${column_name}" fbmaxlength="${length}" fb:isedit="isEdit" fb:approvaledit="approvalEdit" hidden></formeditor>
        </span>
        <div class="preview col-sm-8 modelBuilderName" modeltype='${datatype}' id='${column_name}' >
          ${display_name}
        </div>
        <div class="view">
          <div class="row fbinput textinput" fbv-if="fb.edit">
          <label class="noDrag col-form-label col-12">${display_name}</label>
          <div class="col-12">
            <input type="text" class="form-control netGroup noDrag userinput">
          </div>
          <div class="description">

          </div>
          </div>
          <div class="fbResult row" fbv-if="fb.edit == false" hidden>
          <fbtextbox mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fbmaxlength="${length}" fb:isedit="isEdit" fb:approvaledit="approvalEdit" class="col-sm-12" />
          </div>
        </div>
        </div>`;
    },
    getDateInput(display_name,column_name,datatype,table_name,column_id,table_id,table_type) {
      return `<div class="fbrow ui-draggable">
      <a href="#close" class="remove btn btn-danger btn-sm"><i
        class="fas fa-minus-circle icon-white"></i>Remove</a>
      <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
      <span class="configuration">
        <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
        data-target="#propertyModal" modelType="dateInput"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
        <formeditor modelType="dateInput" fblabel="${display_name}" fbv-model="formData.${table_name}.${column_name}" mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fb:isedit="isEdit" fb:approvaledit="approvalEdit" hidden></formeditor>
      </span>
      <div class="preview col-sm-8 modelBuilderName" modeltype='${datatype}' id='${column_name}'>
      ${display_name}
      </div>
      <div class="view">
        <div class="row fbinput dateinput" fbv-if="fb.edit">
        <label class="noDrag col-form-label col-12">${display_name}</label>
        <div class="col-12">
          <input type="date" class="form-control netGroup noDrag datepicker userinput">
        </div>
        <div class="description">

        </div>
        </div>
        <div class="fbResult row" fbv-if="fb.edit == false" hidden>
        <fbdatebox2 mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}"  fb:isedit="isEdit" fb:approvaledit="approvalEdit" class="col-sm-12" />
        </div>
      </div>
      </div>`;
    },
    getDateTimeInput(display_name,column_name,datatype,table_name,column_id,table_id,table_type) {
      return `<div class="fbrow ui-draggable">
        <a href="#close" class="remove btn btn-danger btn-sm"><i
          class="fas fa-minus-circle icon-white"></i>Remove</a>
        <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
        <span class="configuration">
          <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
          data-target="#propertyModal" modelType="dateTimeInput"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
          <formeditor modelType="dateTimeInput" fblabel="${display_name}" fbv-model="formData.${table_name}.${column_name}" mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fb:isedit="isEdit" fb:approvaledit="approvalEdit" hidden></formeditor>
        </span>
        <div class="preview col-sm-8 modelBuilderName" modeltype='${datatype}' id='${column_name}'>
        ${display_name}
        </div>
        <div class="view">
          <div class="row fbinput dateTimeinput" fbv-if="fb.edit">
          <label class="noDrag col-form-label col-12">${display_name}</label>
          <div class="col-12">
            <input type="datetime-local" class="form-control netGroup noDrag datepicker userinput">
          </div>
          <div class="description">

          </div>
          </div>
          <div class="fbResult row" fbv-if="fb.edit == false" hidden>
          <fbdatetimebox mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fb:isedit="isEdit" fb:approvaledit="approvalEdit" class="col-sm-12" />
          </div>
        </div>
        </div>`;
    },
    getFileUpload(display_name,column_name,datatype,table_name, column_id, table_id, table_type) {
      return `<div class="fbrow ui-draggable">
      <a href="#close" class="remove btn btn-danger btn-sm"><i
        class="fas fa-minus-circle icon-white"></i>Remove</a>
      <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
      <span class="configuration">
        <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
        data-target="#propertyModal" modelType="fileUpload"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
        <formeditor modelType="fileUpload" fbv-model="formData.${table_name}.${column_name}" fblabel="${display_name}" mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fb:ismobile="isMobile" fb:isedit="isEdit" fb:fileresponse="fileresponse" fb:attachmentlist="d.attachmentlist" fb:approvaledit="approvalEdit" fb:index="i" hidden></formeditor>
      </span>
      <div class="preview col-sm-8 modelBuilderName" modeltype='${datatype}' id='${column_name}'>
      ${display_name}
      </div>
      <div class="view">
        <div class="row fbinput fileupload" fbv-if="fb.edit">
          <label class="col-form-label noDrag col-sm-11">${display_name}</label>
        <div class="col-12">
          <div class="form-check col-sm-12">
          <form action="/file-upload" class="dropzone dz-clickable">
            <div class="dz-default dz-message">Drag files here to upload</div>
          </form>
          </div>
          <div class="col-12">
          <table class="table">
            <thead>
            <tr>
              <th scope="col">Original Name</th>
              <th scope="col">Remove</th>
              <th scope="col">Download</th>
            </tr>
            </thead>
            <tbody>
            <tr >
              <td></td>
              <td><button class="btn btn-danger btn-block" >Remove</button></td>
              <td><button class="btn btn-info btn-block" >Download</button></td>
            </tr>
            </tbody>
          </table>
          </div>
        </div>

        </div>
        <div class="fbResult row" fbv-if="fb.edit == false" hidden>
        <fbfileupload mb_form_table_id="${table_id}" mb_form_table_type="${table_type}" mb_form_column_id="${column_id}" column_name="${column_name}" fb:ismobile="isMobile" fb:isedit="isEdit" fb:fileresponse="fileresponse" fb:approvaledit="approvalEdit" class="col-sm-12" fb:index="i"  />
        </div>
      </div>
      </div>`;
    },
    getModel() {
      var vm = this;
      api.request(
      this,
      "post",
      "/model_builder/getModelColumn",
      {
        SessionID: helper.getSessionID(),
        LocaleCode: helper.getLocaleCode(),
        Parameters: {
            ID:vm.$route.query.ID
        }
      },
      function(data) {
         if (Object.keys(data.data.model).length > 0) {
            vm.modelBuilder = data.data.model; // Not use in this function, but use in propertyModal's model selection
            console.log(data.data.model);
            var modelColumnArray = [];

            let mainTable = data.data.model.mainTable;
            let mainModel = mainTable.property;

            $(vm.$el)
              .find(".modelBuilder").append(`<div style="color: #78828a"><i class="fas fa-minus"></i>${helper.getWord('Main Table')} ${mainModel.name}</div>`);
            $.each(mainTable.columns, function(key, value) {
              switch (value.datatype) {
                case "int":
                  $(vm.$el).find(".modelBuilder").append(
                      vm.getNumberInput(
                        value.display_name,
                        value.column_name,
                        value.datatype,
                        mainModel.table_name,
                        value.id,
                        mainModel.id,
                        mainModel.type,
                        value.length
                      )
                    );
                  break;
                case "nvarchar":
                  $(vm.$el).find(".modelBuilder").append(
                      vm.getTextInput(
                        value.display_name,
                        value.column_name,
                        value.datatype,
                        mainModel.table_name,
                        value.id,
                        mainModel.id,
                        mainModel.type,
                        value.length
                      )
                    );
                  break;
                case "date":
                  $(vm.$el)
                    .find(".modelBuilder")
                    .append(
                      vm.getDateInput(
                        value.display_name,
                        value.column_name,
                        value.datatype,
                        mainModel.table_name,
                        value.id,
                        mainModel.id,
                        mainModel.type
                      )
                    );
                  break;
                case "datetime":
                  $(vm.$el)
                    .find(".modelBuilder")
                    .append(
                      vm.getDateTimeInput(
                        value.display_name,
                        value.column_name,
                        value.datatype,
                        mainModel.table_name,
                        value.id,
                        mainModel.id,
                        mainModel.type
                      )
                    );
                  break;
                case "decimal":
                  $(vm.$el)
                    .find(".modelBuilder")
                    .append(
                      vm.getNumberInput(
                        value.display_name,
                        value.column_name,
                        value.datatype,
                        mainModel.table_name,
                        value.id,
                        mainModel.id,
                        mainModel.type,
                        value.length
                      )
                    );
                  break;
                case "files":
                  $(vm.$el)
                    .find(".modelBuilder")
                    .append(
                      vm.getFileUpload(
                        value.display_name,
                        value.column_name,
                        value.datatype,
                        mainModel.table_name,
                        value.id,
                        mainModel.id,
                        mainModel.type
                      )
                    );
                  break;
              }
            });

            let subTables = data.data.model.subTables;
            if (subTables.length > 0) {
              $(vm.$el)
                .find(".modelBuilder")
                .append(
                  `<divstyle="color: #78828a"><i class="fas fa-minus"></i>${helper.getWord('Sub Table')}</div>`
                );
            }
            $.each(subTables, function(key, vlaue) {
              let subModel = this.property;
              let subModelColumns = this.columns;
              $(vm.$el)
                .find(".modelBuilder")
                .append(
                  `<div class='preview' style="color: #78828a"><i class="fas fa-minus"></i>${subModel.name}</div>`
                );

              $.each(subModelColumns, function(key, value) {
                value = $(this)[0];
                switch (value.datatype) {
                  case "int":
                    $(vm.$el).find(".modelBuilder").append(
                        vm.getNumberInput(
                          value.display_name,
                          value.column_name,
                          value.datatype,
                          subModel.table_name,
                          value.id,
                          subModel.id,
                          subModel.type,
                          value.length
                        )
                      );
                    break;
                  case "nvarchar":
                    $(vm.$el).find(".modelBuilder").append(
                        vm.getTextInput(
                          value.display_name,
                          value.column_name,
                          value.datatype,
                          subModel.table_name,
                          value.id,
                          subModel.id,
                          subModel.type,
                          value.length
                        )
                      );
                    break;
                  case "date":
                    $(vm.$el).find(".modelBuilder").append(
                        vm.getDateInput(
                          value.display_name,
                          value.column_name,
                          value.datatype,
                          subModel.table_name,
                          value.id,
                          subModel.id,
                          subModel.type
                        )
                      );
                    break;
                  case "datetime":
                    $(vm.$el).find(".modelBuilder").append(
                        vm.getDateTimeInput(
                          value.display_name,
                          value.column_name,
                          value.datatype,
                          mainModel.table_name,
                          value.id,
                          mainModel.id,
                          mainModel.type
                        )
                      );
                    break;
                  case "decimal":
                    $(vm.$el).find(".modelBuilder").append(
                        vm.getNumberInput(
                          value.display_name,
                          value.column_name,
                          value.datatype,
                          subModel.table_name,
                          value.id,
                          subModel.id,
                          subModel.type,
                          value.length
                        )
                      );
                    break;
                  case "files":
                    $(vm.$el).find(".modelBuilder").append(
                        vm.getFileUpload(
                          value.display_name,
                          value.column_name,
                          value.datatype,
                          subModel.table_name,
                          value.id,
                          subModel.id,
                          subModel.type
                        )
                      );
                    break;
                }
              });
            });
          }
         vm.setDraggable();
        //initContainer();
        $(".sidebar-nav").niceScroll();
        //$("#propertyModal").niceScroll();
      },
      function(r) {
        
      }
    ); 

    },
    openModal() {
      var vm = this; //SET Local vm
      $("#propertyModal").on("show.bs.modal", function(event) {
        var $button = $(event.relatedTarget); // Button that triggered the modal
        var $formeditor = $button.next("formeditor");
        $formeditor.attr("modelType", $button.attr("modelType")); //assign model type here .
        vm.$currentFormEditor = $formeditor;
        var $modal = $(this);
        var modelType = vm.$currentFormEditor.attr("modelType");
        var modelTypecheck;
        vm.currentModel = modelType; //Global
        $('[data-toggle="tooltip"]').tooltip({trigger: "hover"});

        /* Show all / hidden model property */
        (function(){
          $("#txt_fblabel").show();
          $("#txt_fblabel").parent().prev().show();

          $("#display-tab").show();
          if(modelType!="ocrbutton"){
            $("#display-tab").click();
            }
          $("#txt_fbhidelabel").show();
          $("#txt_fbhidelabel").siblings().show();

          $("#txt_fbreadonly").show();
          $("#txt_fbreadonly").siblings().show();

          $("#txt_fbinvisible").show();
          $("#txt_fbinvisible").siblings().show();

          $('#txt_fbsubmitcanchange').show();
		      $('#txt_fbsubmitcanchange').siblings().show();

           $('#txt_fbsupportmultiplelanguages').show();
		      $('#txt_fbsupportmultiplelanguages').siblings().show();

          $("#txt_fbplaceholder").show();
          $("#txt_fbplaceholder").parent().prev().show();

          $("#txt_fbhelptext").show();
          $("#txt_fbhelptext").parent().prev().show();

          $("#txt_fbmodelbuilder").show();
          $("#txt_fbmodelbuilder").parent().parent().prev().show();

          $("#txt_fbrows").hide();
          $("#txt_fbrows").parent().prev().hide();

          $("#txt_fblabelposition").show();
          $("#txt_fblabelposition").parent().parent().prev().show();

          $('#txt_fbdecimal_places').hide();
          $('#txt_fbdecimal_places').parent().prev().hide();

          $('#txt_fbinputmask').hide();
          $('#txt_fbinputmask').parent().prev().hide();

          $("#txt_fbdefaultvalue").show();
          $("#txt_fbdefaultvalue").parent().prev().show();

          $("#txt_fbrequired").show();
          $("#txt_fbrequired").siblings().show();

          $("#txt_fbselect").hide();

          $("#txt_fbtype").hide();
          $("#txt_fbtype").prev().hide();

          $("#txt_fbspecificcolumn").hide();
          $("#txt_fbspecificcolumn").prev().hide();

          $("#txt_fbtype2").hide();
          $("#txt_fbtype2").prev().hide();

          $("#txt_fbspecificcolumn2").hide();
          $("#txt_fbspecificcolumn2").prev().hide();

          $('#txt_fbminlength').hide();
          $('#txt_fbminlength').parent().prev().hide();

          $('#txt_fbmaxlength').hide();
          $('#txt_fbmaxlength').parent().prev().hide();

          $('#txt_fbtextcase').hide();
          $('#txt_fbtextcase').prev().hide();

          $("#data-tab").show();
          $("#validation-tab").show();
          $('#condition-tab').hide();
          $('#accessRight-tab').hide();
          $('#logic-tab').hide();

          if (modelType == "detailTable") {
            $("#txt_fbplaceholder").parent().prev().hide();
            $("#txt_fbplaceholder").hide();

            $("#txt_fblabelposition").parent().parent().prev().hide();
            $("#txt_fblabelposition").hide();

            $("#txt_fbreadonly").siblings().hide();
            $("#txt_fbreadonly").hide();

            $("#txt_fbsubmitcanchange").siblings().hide();
            $("#txt_fbsubmitcanchange").hide();

            $("#txt_fbsupportmultiplelanguages").siblings().hide();
            $("#txt_fbsupportmultiplelanguages").hide();



            $("#txt_fbinvisible").siblings().hide();
            $("#txt_fbinvisible").hide();

            $("#txt_fbrequired").siblings().hide();
            $("#txt_fbrequired").hide();

            $("#txt_fbhelptext").hide();
            $("#txt_fbhelptext").parent().prev().hide();

            $("#txt_fbdefaultvalue").hide();
            $("#txt_fbdefaultvalue").parent().prev().hide();

            $("#data-tab").hide();
            $("#validation-tab").hide();

          } else if (modelType == "numberInput") {
            $("#txt_fbtype").show();
            $("#txt_fbtype").prev().show();

            $("#txt_fbspecificcolumn").show();
            $("#txt_fbspecificcolumn").prev().show();

            $('#txt_fbdecimal_places').show();
            $('#txt_fbdecimal_places').prev().show();
            
            $('#txt_fbminlength').show();
            $('#txt_fbminlength').parent().prev().show();

            $('#txt_fbmaxlength').show();
            $('#txt_fbmaxlength').parent().prev().show();
            
            $('#txt_fbinputmask').show();
            $('#txt_fbinputmask').parent().prev().show();

            var fbtype = $(vm.$currentFormEditor).attr('fbtype');
            if(fbtype == 'percentage' || fbtype == 'difference' || fbtype == 'multiplication'||fbtype=='gst'){
              $("#txt_fbspecificcolumn2").empty();
              $("#txt_fbspecificcolumn2").show();
              $("#txt_fbspecificcolumn2").prev().show();
            }

          } else if (modelType == "textArea") {
            $modal.find("#txt_fbrows").show();
            $("#txt_fbrows").parent().prev().show();
            
            $('txt_fbtextcase').show();
            $('#txt_fbtextcase').parent().prev().show();
            
            $('#txt_fbminlength').show();
            $('#txt_fbminlength').parent().prev().show();

            $('#txt_fbmaxlength').show();
            $('#txt_fbmaxlength').parent().prev().show();

          } else if (modelType == "dateInput" || modelType == "dateTimeInput") {
            $("#txt_fbplaceholder").hide();
            $("#txt_fbplaceholder").parent().prev().hide();

            $("#txt_fbtype").show();
            $("#txt_fbtype").prev().show();

            $("#txt_fbspecificcolumn").show();
            $("#txt_fbspecificcolumn").prev().show();

          } else if (modelType == "textInput") {
            $("#txt_fbtype").show();
            $("#txt_fbtype").prev().show();

            $("#txt_fbspecificcolumn").show();
            $("#txt_fbspecificcolumn").prev().show();

            $('#txt_fbtextcase').show();
            $('#txt_fbtextcase').prev().show();

            $('#txt_fbminlength').show();
            $('#txt_fbminlength').parent().prev().show();

            $('#txt_fbmaxlength').show();
            $('#txt_fbmaxlength').parent().prev().show();

            var fbtype = $(vm.$currentFormEditor).attr('fbtype');
            if(fbtype == 'postcode'){
              $("#txt_fbspecificcolumn2").empty();
              $("#txt_fbspecificcolumn2").show();
              $("#txt_fbspecificcolumn2").prev().show();
            }

          } else if (modelType == "selectBox" || modelType == "checkBoxes") {
            $modal.find("#txt_fbselect").show();

            $("#txt_fbtype").show();
            $("#txt_fbtype").prev().show();

            $("#txt_fbspecificcolumn").show();
            $("#txt_fbspecificcolumn").prev().show();

            var fbtype = $(vm.$currentFormEditor).attr('fbtype');
            if(fbtype == 'postcode'){
              $("#txt_fbspecificcolumn2").empty();
              $("#txt_fbspecificcolumn2").show();
              $("#txt_fbspecificcolumn2").prev().show();
            }

          } else if (modelType == "preparerselectbox") {
             $("#txt_fbplaceholder").parent().prev().hide();
            $("#txt_fbplaceholder").hide();

             $("#validation-tab").hide();

            $("#txt_fbreadonly").hide();
            $("#txt_fbreadonly").siblings().hide();


            $("#txt_fbmodelbuilder").hide();
            $("#txt_fbmodelbuilder").parent().parent().prev().hide();
            
            

            $("#data-tab").hide();
    

          }
          
        
          else if (modelType == "radioBox") {
            $modal.find("#txt_fbselect").show();

            $("#txt_fbplaceholder").parent().prev().hide();
            $("#txt_fbplaceholder").hide();

            $("#txt_fblabelposition").hide();
            $("#txt_fblabelposition").parent().parent().prev().hide();

            $("#txt_fbhelptext").hide();
            $("#txt_fbhelptext").parent().prev().hide();

          } else if (modelType == "checkBox") {
            $modal.find("#txt_fbselect").show();

            $("#txt_fblabelposition").hide();
            $("#txt_fblabelposition").parent().parent().prev().hide();

            $("#txt_fbhelptext").hide();
            $("#txt_fbhelptext").parent().prev().hide();

            $("#txt_fbplaceholder").parent().prev().hide();
            $("#txt_fbplaceholder").hide();

            $("#txt_fbreadonly").siblings().hide();
            $("#txt_fbreadonly").hide();

            $("#txt_fbhidelabel").hide();
            $("#txt_fbhidelabel").siblings().hide();

          } else if (modelType == "dayOrHourInput") {
            

          } else if (modelType == "signature") {
            $("#txt_fbplaceholder").parent().prev().hide();
            $("#txt_fbplaceholder").hide();

            $("#txt_fbdefaultvalue").hide();
            $("#txt_fbdefaultvalue").parent().prev().hide();

            $("#data-tab").hide();
          }     
        })();

        /*Clear fbtype's specific columns*/
        (function(){
          $('#txt_fbspecificcolumn').find('.form-group').empty();
           $('#txt_fbspecificcolumn2').find('.form-group').empty();
          $('#txt_fbspecificcolumn2').empty();
        })();

        //Modal-Data-Tab Default number  / Date  / Checkbox input
        if (modelType == "numberInput") {
          $modal.find(".modal-body #txt_fbdefaultvalue").attr("type", "number");
          $modal.find(".modal-body #txt_fbdefaultvalue").attr("step", "0.01");
        } else if (modelType == "dateInput" || modelType == "dateTimeInput") {
          $modal.find(".modal-body #txt_fbdefaultvalue").attr("type", "date");
        } else if (modelType == "checkBox") {
          $modal.find(".modal-body #txt_fbdefaultvalue").attr("type", "checkbox");
        } else {
          $modal.find(".modal-body #txt_fbdefaultvalue").attr("type", "text");
        }

        /* Load Model Builder to Modal (Data Model)*/
        if (vm.modelBuilder) {
          $("#propertyModalLabel").html('Properties');
          if (vm.modelBuilder.subTables) {
            let subTables = vm.modelBuilder.subTables;
            let mainTable = vm.modelBuilder.mainTable;

            if (
              vm.$currentFormEditor
                .parents(".fbrow")
                .first()
                .find(".fbDetailTable").length > 0
            ) {
              //Detail Table
              $(vm.$el)
                .find("#txt_fbmodelbuilder")
                .empty();
              $.each(subTables, function(key, value) {
                let option = `<option value="${subTables[key].property.id}">${subTables[key].property.name}</option>`;
                $(vm.$el)
                  .find("#txt_fbmodelbuilder")
                  .append(option);
              });
            } else {
              //Not Detail Table(input)
              $(vm.$el).find("#txt_fbmodelbuilder").empty();
              if (vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0) {
                //components inside the detail table

                $.each(subTables, function(key1, value) {
                  let columns = subTables[key1].columns;
                  $.each(columns, function(key2, value) {
                    switch (columns[key2].datatype) {
                      case "nvarchar":
                        modelTypecheck = [
                          "textInput",
                          "textArea",
                          "selectBox",
                          "radioBox",
                          "checkBox",
                          "checkBoxes",
                          "dayOrHourInput",
                          "signature"
                        ];
                        break;
                      case "int":
                        modelTypecheck = "numberInput";
                        break;
                      case "datetime":
                        modelTypecheck = "dateTimeInput";
                        break;
                      case "date":
                        modelTypecheck = "dateInput";
                        break;
                      case "decimal":
                        modelTypecheck = "numberInput";
                        break;
                      case "files":
                        modelTypecheck = "fileUpload";
                        break;
                      case "uniqueidentifier":
                        modelTypecheck = "selectBox";
                        break;
                    }
                    if (modelTypecheck.includes(modelType)) {
                      let option = `<option value="${subTables[key1].property.table_name}.${columns[key2].column_name}">${columns[key2].display_name}</option>`;
                      $(vm.$el)
                        .find("#txt_fbmodelbuilder")
                        .append(option);
                    }
                  });
                });
              } else {
                //components outside the detail table
                $(vm.$el)
                  .find("#txt_fbmodelbuilder")
                  .empty();
                let columns = mainTable.columns;
                $.each(columns, function(key, value) {
                  var modelTypecheck;
                  switch (columns[key].datatype) {
                    case "nvarchar":
                      modelTypecheck = [
                        "textInput",
                        "textArea",
                        "selectBox",
                        "radioBox",
                        "checkBox",
                        "checkBoxes",
                        "dayOrHourInput",
                        "signature"
                      ];
                      break;
                    case "int":
                      modelTypecheck = "numberInput";
                      break;
                    case "datetime":
                      modelTypecheck = "dateTimeInput";
                      break;
                    case "date":
                      modelTypecheck = "dateInput";
                      break;
                    case "decimal":
                      modelTypecheck = "numberInput";
                      break;
                    case "files":
                      modelTypecheck = "fileUpload";
                      break;
                    case "uniqueidentifier":
                        modelTypecheck = "selectBox";
                        break;
                  }
                  if (modelTypecheck.includes(modelType)) {
                    let option = `<option value="${mainTable.property.table_name}.${columns[key].column_name}">${columns[key].display_name}</option>`;
                    $(vm.$el)
                      .find("#txt_fbmodelbuilder")
                      .append(option);
                  }
                });
              }
            }
          }
        }

        //settled select options
        if (vm.$currentFormEditor.children().length >= 0) {
          $modal.find(".modal-body #txt_fbselect tbody").empty();

          for (let i = 1; i <= vm.$currentFormEditor.children().length; i++) {
            let value = vm.$currentFormEditor
              .find(`option:nth-child(${i})`)
              .attr("fbselectvalue")
              .replace(/ /g, "&#32;");
            let label = vm.$currentFormEditor
              .find(`option:nth-child(${i})`)
              .attr("fbselectlabel")
              .replace(/ /g, "&#32;");
            let tag = `<tr>
              <td><input type="text" placeholder="Label" class="form-control input-sm selectlabel" value=${label}></td>
              <td><input type="text" placeholder="Value" class="form-control input-sm selectvalue" value=${value}></td>
              <td><button class="btn btn-danger delete"><i class="fas fa-minus-circle icon-white"></i></button></td>
              </tr>`;
            $modal.find(".modal-body #txt_fbselect tbody").append(tag);
          }

          $("td")
            .find("button")
            .on("click", function(e) {
              $button = $(e.currentTarget);
              var $targetRow = $button.parents("tr").first();
              $targetRow.remove();
            });
        }

        //Settled fbtype options
        if (modelType == "numberInput") {
          let option = `<option value=""></option>
						<option value="count">Count</option>
            <option value="amount">Amount</option>
            <option value="difference">Difference</option>
            <option value="multiplication">Multiplication</option>
            <option value="percentage">Percentage</option>
            <option value="gst">GST</option>
						<option value="dateDifference"> Date Difference</option>
						<option value="annualLeave">Annual Leave</option>`; //formbuiilder annual leave is required with modelbuilder total_annual_leave
          $modal.find(".modal-body #txt_fbtype select").empty().append(option);
        } else if (modelType == "textInput" || modelType == "selectBox") {
          let option = `<option value=""></option>
						<option value="postcode">Suburb / Post Code</option>
						`;
          //<option value="employeename">Employee Name</option>
          $modal.find(".modal-body #txt_fbtype select").empty().append(option);
        } else if (modelType == "dateInput" || modelType == "dateTimeInput") {
          let option = `<option value=""></option>
            <option value="pastToNow">Past to Now</option>
            <option value="nowToFuture">Now to Future</option>
						<option value="startFromDate">Date start form</option>
						`;
          //<option value="submitdate">Submit Date</option><option value="approvaldate">Approval Date</option>
          $modal.find(".modal-body #txt_fbtype select").empty().append(option);
        }
        $("#txt_fbspecificcolumn").prev().html(helper.getWord('Corresponding Table')+' / '+helper.getWord('Column'))
        if (modelType == "fileUpload") {
         $("#txt_fbplaceholder").parent().prev().hide();
            $("#txt_fbplaceholder").hide();

            $("#txt_fblabelposition").hide();
            $("#txt_fblabelposition").parent().parent().prev().hide();

            $("#txt_fbreadonly").hide();
            $("#txt_fbreadonly").siblings().hide();

            $("#txt_fbsubmitcanchange").hide();
            $("#txt_fbsubmitcanchange").siblings().hide();


            $("#data-tab").hide();
      

          }else if (modelType == "ocrbutton") {

          $("#display-tab").hide();
            $("#data-tab").click();
          
          $("#validation-tab").hide();
          $("#txt_fbdefaultvalue").hide();
          $("#defaultValueLabel").hide();
          
          $("#txt_fbspecificcolumn").empty();

          
           $("#txt_fbspecificcolumn").show();
           $("#txt_fbspecificcolumn").prev().show();
          
          $("#txt_fbspecificcolumn2").show();
           $("#txt_fbspecificcolumn2").prev().show();

          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          var ocrDate_column = vm.$currentFormEditor.attr("fbtypedetail");
          var ocrAmount_column  = vm.$currentFormEditor.attr("fbtypedetail");
          if(model){
            model = model.split(".").slice(1).join(".");
          }
          
          console.log( vm.$currentFormEditor.attr("fbtypedetail"));
          if(ocrDate_column){
            ocrDate_column = ocrDate_column.replace(/'/g , '').slice(1, -1).split(',')[1];
          }

          if(ocrAmount_column){
            ocrAmount_column = ocrAmount_column.replace(/'/g , '').slice(1, -1).split(',')[2];
          }
          
          $("#txt_fbspecificcolumn").prev().html(helper.getWord('Date')+':');
             var input_column = `<div class="form-group">`;
          $('#txt_fbspecificcolumn').append(input_column);
          $.each(mainTable.columns, function(key, column) { //Load related maintable column
            let value =mainTable.property.table_name + "." + column.column_name;
   
            if (model != value &&(column.datatype == "date"||column.datatype == "datetime")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="percentage" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
              if(value == ocrDate_column){
                $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
              }
            }
          });

          $.each(subTables, function(key, subtable) { //Load related subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == "date"||column.datatype == "datetime")) {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" name="percentage" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
                if(value == ocrDate_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });
          input_column=`</div>`;
          $('#txt_fbspecificcolumn').append(input_column);

          $('#txt_fbspecificcolumn2').prev().html(helper.getWord('Total Amount')+':'); //Create percentage input box for user define
           input_column = `<div class="form-group">`;
          $('#txt_fbspecificcolumn2').append(input_column);

        

          $.each(mainTable.columns, function(key, column) { //Load related maintable column
            let value =mainTable.property.table_name + "." + column.column_name;
            if (model != value &&(column.datatype == "int" || column.datatype == "decimal")) {
              let option= `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="txt_fbpercentage_value" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                 $("#txt_fbspecificcolumn2").find(".form-group").append(option);
              if(value == ocrAmount_column){
                $("#txt_fbspecificcolumn2").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
              }
            }
          });

          $.each(subTables, function(key, subtable) { //Load related subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;
              if (model != value && (column.datatype == "int" || column.datatype == "decimal")) {
                 let option= `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" name="txt_fbpercentage_value" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                     $("#txt_fbspecificcolumn2").find(".form-group").append(option);
                if(value == ocrAmount_column){
                  $("#txt_fbspecificcolumn2").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

              input_column=`</div>`;
          $('#txt_fbspecificcolumn2').append(input_column);




            $("#txt_fbplaceholder").parent().prev().hide();
            $("#txt_fbplaceholder").hide();

            $("#txt_fblabelposition").hide();
            $("#txt_fblabelposition").parent().parent().prev().hide();

            $("#txt_fbreadonly").hide();
            $("#txt_fbreadonly").siblings().hide();

            $("#txt_fbsubmitcanchange").hide();
            $("#txt_fbsubmitcanchange").siblings().hide();

               $("#txt_fbsupportmultiplelanguages").hide();
            $("#txt_fbsupportmultiplelanguages").siblings().hide();
      
          }        
          
          else

        //Sum / Count / Percentage/ DateDifference / betweenDate / startFromDate / annualLeave detail Table
        if (modelType == "numberInput" && vm.$currentFormEditor.attr("fbtype") == "amount") {
          $("#txt_fbspecificcolumn").find(".form-group").empty();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          
          if(model){
            model = model.split(".").slice(1).join(".");
          }

          $.each(mainTable.columns, function(key, column) {
            let value = mainTable.property.table_name + "." + column.column_name;
            if (model != value && (column.datatype == "decimal" || column.datatype == "int")) {
              let option = `
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" value="${value}">
                  <label class="custom-control-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
            }
          });

          $("#txt_fbspecificcolumn").find(".form-group").append("<hr>");

          $.each(subTables, function(key, subtable) {
            $.each(subtable.columns, function(key, column) {
              let value =
                subtable.property.table_name + "." + column.column_name;

              if (
                model != value &&
                (column.datatype == "decimal" || column.datatype == "int")
              ) {
                let option = `
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" value="${value}">
                    <label class="custom-control-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
              }
            });
          });

          let options = $(".modal-body #txt_fbspecificcolumn").children().children();
          if (
            vm.$currentFormEditor.attr("fbtypedetail") != null &&
            vm.$currentFormEditor.attr("fbtypedetail") != undefined
          ) {
            let checked = vm.$currentFormEditor.attr("fbtypedetail");
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, "").split(",");
            }

            $.each(checked, function(key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function(key, option) {
              if (
                checked.includes(
                  $(option).find("input").val()
                )
              ) {
                $(option).find("input").prop("checked", true);
              }
            });
          }
        } else if (modelType == "numberInput" && vm.$currentFormEditor.attr("fbtype") == "count") {
          $("#txt_fbspecificcolumn").find(".form-group").empty();
          let subTables = vm.modelBuilder.subTables;
          let checked = vm.$currentFormEditor.attr("fbtypedetail");
          
          if(checked){
            checked = checked.slice(1, -1).replace(/'/g, "").split(",").pop();
          }

          $.each(subTables, function(key, subtable) {
            let option = `
              <div class="form-check">
                <input class="form-check-input" type="radio" name="count" value="${subtable.property.table_name}">
                <label class="form-check-label">${subtable.property.name}</label>
              </div>`;
            $("#txt_fbspecificcolumn").find(".form-group").append(option);
          });

          let options = $(".modal-body #txt_fbspecificcolumn").children().children().find("input");

          $.each(options, function(key, option) {
            if (checked == $(option).val()) {
              $(option).prop("checked", true);
            }
          });
        } else if (modelType == "numberInput" &&vm.$currentFormEditor.attr("fbtype") == "difference"){
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          let difference_type = vm.$currentFormEditor.attr("fbtypedetail");

          if(model){
            model = model.split(".").slice(1).join(".");
          }
          
          if(difference_type){
            difference_type = difference_type.replace(/'/g , '').slice(1, -1).split(',').pop();
          }

          $.each(mainTable.columns, function(key, column) {
            let value = mainTable.property.table_name + "." + column.column_name;
            if (model != value && (column.datatype == "decimal" || column.datatype == "int")) {
              let option = `
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" value="${value}">
                  <label class="custom-control-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
            }
          });
          
          $("#txt_fbspecificcolumn").find(".form-group").append("<hr>");

          $.each(subTables, function(key, subtable) {
            $.each(subtable.columns, function(key, column) {
              let value =
                subtable.property.table_name + "." + column.column_name;

              if (
                model != value &&
                (column.datatype == "decimal" || column.datatype == "int")
              ) {
                let option = `
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" value="${value}">
                    <label class="custom-control-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
              }
            });
          });

          let options = $(".modal-body #txt_fbspecificcolumn").children().children();
          if (vm.$currentFormEditor.attr("fbtypedetail")) {
            let checked = vm.$currentFormEditor.attr("fbtypedetail");
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, "").split(",");
            }
            $.each(checked, function(key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function(key, option) {
              if (
                checked.includes(
                  $(option).find("input").val()
                )
              ) {
                $(option).find("input").prop("checked", true);
              }
            });
          }

          $('#txt_fbspecificcolumn2').prev().html('Difference Type'); //Set Difference Sequencial
          let input_column = `
            <select id="txt_fbdifference_type" class="custom-select">
              <option value=""></option>
              <option value="sequential">Sequential</option>
              <option value="invert">Invert</option>
            </select>
          `;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbdifference_type').val(difference_type);//Load Predefined sequential to the input box 

        } else if (modelType == "numberInput" && vm.$currentFormEditor.attr("fbtype") == "multiplication"){
          $("#txt_fbspecificcolumn").find(".form-group").empty();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          var defined_column = vm.$currentFormEditor.attr("fbtypedetail");
          var multiplication_value = vm.$currentFormEditor.attr("fbtypedetail");
          if(model){
            model = model.split(".").slice(1).join(".");
          }
          
          if(defined_column){
            defined_column = defined_column.replace(/'/g , '').slice(1, -1).split(',')[1];
          }

          
          if(multiplication_value){
            multiplication_value = multiplication_value.replace(/'/g , '').slice(1, -1).split(',').pop();
          }

          $.each(mainTable.columns, function(key, column) { //Load related maintable column
            let value =mainTable.property.table_name + "." + column.column_name;
            if (model != value &&(column.datatype == '"nvarchar"' ||column.datatype == "int" || column.datatype == "decimal")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="percentage" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
              if(value == defined_column){
                $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
              }
            }
          });

          $.each(subTables, function(key, subtable) { //Load related subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == '"nvarchar"' || column.datatype == "int" || column.datatype == "decimal")) {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" name="percentage" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
                if(value == defined_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

          $('#txt_fbspecificcolumn2').prev().html('Multiplication Value'); //Create percentage input box for user define
          var input_column = `
                  <label class="col-form-label col-12">Multiplication</label>
                  <div class="col-sm-12">
                    <input type="number" id="txt_fbmultiplication_value" class="form-control" placeholder="10"/>
                  </div>`;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbmultiplication_value').val(multiplication_value);//Load Predefined percentage to the input box 

        }  else if (modelType == "numberInput" && vm.$currentFormEditor.attr("fbtype") == "percentage") {
          $("#txt_fbspecificcolumn").find(".form-group").empty();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          var defined_column = vm.$currentFormEditor.attr("fbtypedetail");
          var percentage_value = vm.$currentFormEditor.attr("fbtypedetail")
          if(model){
            model = model.split(".").slice(1).join(".");
          }
          
          if(defined_column){
            defined_column = defined_column.replace(/'/g , '').slice(1, -1).split(',')[1];
          }

          if(percentage_value){
            percentage_value = percentage_value.replace(/'/g , '').slice(1, -1).split(',')[2];
          }
          

          $.each(mainTable.columns, function(key, column) { //Load related maintable column
            let value =mainTable.property.table_name + "." + column.column_name;
            if (model != value &&(column.datatype == '"nvarchar"' ||column.datatype == "int" || column.datatype == "decimal")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="percentage" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
              if(value == defined_column){
                $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
              }
            }
          });

          $.each(subTables, function(key, subtable) { //Load related subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == '"nvarchar"' || column.datatype == "int" || column.datatype == "decimal")) {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" name="percentage" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
                if(value == defined_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

          $('#txt_fbspecificcolumn2').prev().html('Percentage Value'); //Create percentage input box for user define
          var input_column = `
                  <label class="col-form-label col-12">Percentage</label>
                  <div class="col-sm-12">
                    <input type="number" id="txt_fbpercentage_value" class="form-control" placeholder="10%"/>
                  </div>`;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbpercentage_value').val(percentage_value);//Load Predefined percentage to the input box 

        }   else if (modelType == "numberInput" && vm.$currentFormEditor.attr("fbtype") == "gst") {
          $("#txt_fbspecificcolumn").find(".form-group").empty();
          $("#txt_fbspecificcolumn2").find(".form-group").empty();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          var defined_column = vm.$currentFormEditor.attr("fbtypedetail");
          var percentage_value = vm.$currentFormEditor.attr("fbtypedetail")
          if(model){
            model = model.split(".").slice(1).join(".");
          }
          
          console.log( vm.$currentFormEditor.attr("fbtypedetail"));
          if(defined_column){
            defined_column = defined_column.replace(/'/g , '').slice(1, -1).split(',')[1];
          }

          if(percentage_value){
            percentage_value = percentage_value.replace(/'/g , '').slice(1, -1).split(',')[2];
          }
          

          $.each(mainTable.columns, function(key, column) { //Load related maintable column
            let value =mainTable.property.table_name + "." + column.column_name;
            if (model != value &&(column.datatype == "int" || column.datatype == "decimal")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="percentage" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
              if(value == defined_column){
                $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
              }
            }
          });

          $.each(subTables, function(key, subtable) { //Load related subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == "int" || column.datatype == "decimal")) {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" name="percentage" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
                if(value == defined_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

          $('#txt_fbspecificcolumn2').prev().html(helper.getWord('PercentageValueCol')); //Create percentage input box for user define
          var input_column = `<div class="form-group">`;
          $('#txt_fbspecificcolumn2').append(input_column);

        

          $.each(mainTable.columns, function(key, column) { //Load related maintable column
            let value =mainTable.property.table_name + "." + column.column_name;
            if (model != value &&(column.datatype == "nvarchar")) {
              let option= `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="txt_fbpercentage_value" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                 $("#txt_fbspecificcolumn2").find(".form-group").append(option);
              if(value == percentage_value){
                $("#txt_fbspecificcolumn2").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
              }
            }
          });

          $.each(subTables, function(key, subtable) { //Load related subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == "nvarchar")) {
                 let option= `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" name="txt_fbpercentage_value" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                     $("#txt_fbspecificcolumn2").find(".form-group").append(option);
                if(value == percentage_value){
                  $("#txt_fbspecificcolumn2").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

              input_column=`</div>`;
          $('#txt_fbspecificcolumn2').append(input_column);

           $('.modal-body #txt_fbpercentage_value').val(percentage_value);

        } 
        else if (modelType == "numberInput" && vm.$currentFormEditor.attr("fbtype") == "dateDifference") {
          $("#txt_fbspecificcolumn")
            .find(".form-group")
            .empty();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          
          if(model){
            model = model.split(".").slice(1).join(".");
          }

          $.each(mainTable.columns, function(key, column) {
            let value =
              mainTable.property.table_name + "." + column.column_name;
            if (
              model != value &&
              (column.datatype == "date" || column.datatype == "datetime")
            ) {
              let option = `
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" value="${value}">
                  <label class="custom-control-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn")
                .find(".form-group")
                .append(option);
            }
          });
          $("#txt_fbspecificcolumn")
            .find(".form-group")
            .append("<hr>");
          $.each(subTables, function(key, subtable) {
            $.each(subtable.columns, function(key, column) {
              let value =
                subtable.property.table_name + "." + column.column_name;

              if (
                model != value &&
                (column.datatype == "date" || column.datatype == "datetime")
              ) {
                let option = `
                  <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" value="${value}">
                    <label class="custom-control-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn")
                  .find(".form-group")
                  .append(option);
              }
            });
          });

          let options = $(".modal-body #txt_fbspecificcolumn")
            .children()
            .children();
          if (vm.$currentFormEditor.attr("fbtypedetail")) {
            let checked = vm.$currentFormEditor.attr("fbtypedetail");

            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, "").split(",");
            }
            $.each(checked, function(key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function(key, option) {
              if (
                checked.includes(
                  $(option)
                    .find("input")
                    .val()
                )
              ) {
                $(option)
                  .find("input")
                  .prop("checked", true);
              }
            });
          }
        } else if (modelType == "numberInput" &&vm.$currentFormEditor.attr("fbtype") == "annualLeave") {
          //NO specific detail table selection
        } else if ((modelType == "textInput" || modelType == "selectBox") && vm.$currentFormEditor.attr("fbtype") == "postcode") {
          $("#txt_fbspecificcolumn").find(".form-group").empty();
          
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          var defined_country = vm.$currentFormEditor.attr("fbtypedetail");

          if(model){
            model = model.split(".").slice(1).join(".");
          }

          if(defined_country){
            defined_country = defined_country.replace(/'/g , '').slice(1, -1).split(',')[2];
          }

          $.each(mainTable.columns, function(key, column) { //load main table column
            let value = mainTable.property.table_name + "." + column.column_name;
            if (model != value && (column.datatype == "nvarchar" || column.datatype == "int" || column.datatype == "decimal")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
            }
          });

          $("#txt_fbspecificcolumn").find(".form-group").append("<hr>");

          $.each(subTables, function(key, subtable) { //load sub table column
            $.each(subtable.columns, function(key, column) {
              let value = subtable.property.table_name + "." + column.column_name;

              if ( model != value && (column.datatype == "nvarchar" || column.datatype == "int" || column.datatype == "decimal")) {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
              }
            });
          });

          let options = $(".modal-body #txt_fbspecificcolumn").children().children(); //load predefined column
          if (vm.$currentFormEditor.attr("fbtypedetail")) {
            let checked = vm.$currentFormEditor.attr("fbtypedetail");
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, "").split(",");
            }
            $.each(checked, function(key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function(key, option) {
              if ( checked.includes( $(option).find("input").val())) {
                $(option).find("input").prop("checked", true);
              }
            });
          }

          $('#txt_fbspecificcolumn2').prev().html('Country'); //Set country selection
          let input_column = `
              <select id="txt_fbpostcode_country" class="form-control">
                <option value=""></option>
                <option value="australia">Australia</option>
                <option value="usa">USA</option>
              </select>
          `;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbpostcode_country').val(defined_country);//Load Predefined percentage to the input box 


        } else if ( modelType == "dateInput" && vm.$currentFormEditor.attr("fbtype") == "betweenDate") {
          $("#txt_fbspecificcolumn")
            .find(".form-group")
            .empty();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          
          if(model){
            model = model.split(".").slice(1).join(".");
          }

          $.each(mainTable.columns, function(key, column) {
            let value =
              mainTable.property.table_name + "." + column.column_name;
            if (model != value && column.datatype == "date") {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn")
                .find(".form-group")
                .append(option);
            }
          });
          $("#txt_fbspecificcolumn")
            .find(".form-group")
            .append("<hr>");
          $.each(subTables, function(key, subtable) {
            $.each(subtable.columns, function(key, column) {
              let value =
                subtable.property.table_name + "." + column.column_name;

              if (model != value && column.datatype == "date") {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn")
                  .find(".form-group")
                  .append(option);
              }
            });
          });

          let options = $(".modal-body #txt_fbspecificcolumn")
            .children()
            .children();
          if (vm.$currentFormEditor.attr("fbtypedetail")) {
            let checked = vm.$currentFormEditor.attr("fbtypedetail");
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, "").split(",");
            }
            $.each(checked, function(key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function(key, option) {
              if (
                checked.includes(
                  $(option)
                    .find("input")
                    .val()
                )
              ) {
                $(option)
                  .find("input")
                  .prop("checked", true);
              }
            });
          }
        } else if ( modelType == "dateInput" && vm.$currentFormEditor.attr("fbtype") == "startFromDate") {
          $("#txt_fbspecificcolumn").find(".form-group").empty();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          
          if(model){
            model = model.split(".").slice(1).join(".");
          }

          $.each(mainTable.columns, function(key, column) { //Load maintable column
            let value = mainTable.property.table_name + "." + column.column_name;
            if (model != value && column.datatype == "date") {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
            }
          });
          console.log('reached here');
          $("#txt_fbspecificcolumn").find(".form-group").append("<hr>");
          $.each(subTables, function(key, subtable) { //load subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;

              if (model != value && column.datatype == "date") {
                let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" value="${value}">
                <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
              }
            });
          });

          let options = $(".modal-body #txt_fbspecificcolumn").children().children(); //load predefined / check value into column
          if (vm.$currentFormEditor.attr("fbtypedetail")) {
            let checked = vm.$currentFormEditor.attr("fbtypedetail");

            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, "").split(",");
            }

            $.each(checked, function(key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function(key, option) {
              if (checked.includes($(option).find("input").val())) {
                $(option).find("input").prop("checked", true);
              }
            });
          }
        } else {
          $(".modal-body #txt_fbspecificcolumn").hide();
          $(".modal-body #txt_fbspecificcolumn").prev().hide();
          $("#txt_fbspecificcolumn").find(".form-group").empty();
        }

        /* Load attributes to modal */
        (function(){
          $modal.find(".modal-title").text(helper.getWord("Properties"));
          $modal.find(".modal-body #txt_fblabel").val(vm.$currentFormEditor.attr("fblabel"));
          $modal.find(".modal-body #txt_fbhidelabel").prop("checked", vm.$currentFormEditor.attr("fbhidelabel") == "true");
          $modal.find(".modal-body #txt_fbreadonly").prop("checked", vm.$currentFormEditor.attr("fbreadonly") == "true");
          $modal.find(".modal-body #txt_fbsubmitcanchange").prop("checked", vm.$currentFormEditor.attr("fbsubmitcanchange") == "true");
           $modal.find(".modal-body #txt_fbsupportmultiplelanguages").prop("checked", vm.$currentFormEditor.attr("fbsupportmultiplelanguages") == "true");
          $modal.find(".modal-body #txt_fbinvisible").prop("checked", vm.$currentFormEditor.attr("fbinvisible") == "true");
          $modal.find(".modal-body #txt_fbrequired").prop("checked", vm.$currentFormEditor.attr("fbrequired") == "true");
          $modal.find(".modal-body #txt_fbplaceholder").val(vm.$currentFormEditor.attr("fbplaceholder"));
          $modal.find(".modal-body #txt_fbhelptext").val(vm.$currentFormEditor.attr("fbhelptext"));
          $modal.find(".modal-body #txt_fbtooltip").val(vm.$currentFormEditor.attr("fbtooltip"));
          $modal.find(".modal-body #txt_fblabelposition").val(vm.$currentFormEditor.attr("fblabelposition"));
          $modal.find(".modal-body #txt_fbdefaultvalue").val(vm.$currentFormEditor.attr("value"));  
          $modal.find(".modal-body #txt_fbdefaultvalue").attr('maxlength', vm.$currentFormEditor.attr('fbmaxlength'));
          $modal.find(".modal-body #txt_fbminlength").val(vm.$currentFormEditor.attr("fbminlength"));
          $modal.find(".modal-body #txt_fbmaxlength").val(vm.$currentFormEditor.attr("fbmaxlength"));
          
          if(vm.$currentFormEditor.attr('fbinputmask')){
            $modal.find(".modal-body #txt_fbinputmask").val(vm.$currentFormEditor.attr("fbinputmask").split(':')[1].slice(1,-1));
          }else{
            $modal.find(".modal-body #txt_fbinputmask").val(vm.$currentFormEditor.attr("fbinputmask"));
          }

          if(vm.$currentFormEditor.attr('fbmaxlength')){
            $modal.find(".modal-body #txt_fbdefaultvalue").attr('placeholder', 'Max. Value: ' + vm.$currentFormEditor.attr('fbmaxlength'));
          }else{
            $modal.find(".modal-body #txt_fbdefaultvalue").attr('placeholder','');
          }
          $modal.find(".modal-body #txt_fbrows").val(vm.$currentFormEditor.attr("fbrows"));
          $modal.find(".modal-body #txt_fbtype").find("select").val(vm.$currentFormEditor.attr("fbtype"));
          if (modelType == "detailTable") {
            $modal.find(".modal-body #txt_fbmodelbuilder").val(vm.$currentFormEditor.attr("mb_form_table_id"));
          } else {
            if(vm.$currentFormEditor.attr("fbv-model")){
              $modal.find(".modal-body #txt_fbmodelbuilder").val(
                vm.$currentFormEditor.attr("fbv-model").split(".").slice(1).join(".")
              );
            }
          }

          if (modelType == "checkBox") {
            $modal.find(".modal-body #txt_fbdefaultvalue").prop("checked", vm.$currentFormEditor.attr("value") == "true");
          } else {
            $modal.find(".modal-body #txt_fbdefaultvalue").prop("checked", vm.$currentFormEditor.attr("value") == "true");
          }
        })();
      });
    },
    temporarySave() {
      var vm = this;
      $("#btn_propertyConfirm").click(function(e) {
        e.preventDefault();
        var $modal = $("#propertyModal");
        var $view = vm.$currentFormEditor.parents(".fbrow").first().find(".view"); 

        let modelType = vm.$currentFormEditor.attr("modelType");
        if (modelType == "detailTable") {
          let selectedTableVal = $modal.find(".modal-body #txt_fbmodelbuilder").val();

          let fbhidelabel = $modal.find(".modal-body #txt_fbhidelabel").is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", fbhidelabel);

          let fblabel = $("#txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", fblabel);

          let subTables = vm.modelBuilder.subTables;
          $.each(subTables, function(key, value) {
            let prop = value.property;
            if (selectedTableVal) {
              if (selectedTableVal.split("_").pop() == prop.id) {
                let $detailTable = vm.$currentFormEditor.closest(".fbrow").find(".view .fbDetailTable").first(); // Assumption: get the first subtable
                let $addDetailButton = $detailTable.children("button");
                $addDetailButton.attr("fbtablename", prop.table_name);

                let $removeDetailButton = $detailTable.find('a[fbv-on\\:click*="removeDetailClick"]').first();
                $removeDetailButton.attr("fbtablename", prop.table_name);

                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                vm.$currentFormEditor.attr("fbv-for","(d, i) in formData." + prop.table_name);
                vm.$currentFormEditor.parents(".fbrow").first().find(".cardDetail").attr("fbv-for", "(d, i) in formData." + prop.table_name);
                vm.$currentFormEditor.parents(".fbrow").first().find(".cardDetail").attr("fb:key", "d.id");
              }
            }
          });
        } else if (modelType == "textInput") {
          let fblabel = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", fblabel);

          let fbhidelabel = $modal.find(".modal-body #txt_fbhidelabel").is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", fbhidelabel);

          let fbreadonly = $modal.find(".modal-body #txt_fbreadonly").is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", fbreadonly);

          let fbsubmitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", fbsubmitcanchange);

          let fbsupportmultiplelanguages = $modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let fbrequired = $modal.find(".modal-body #txt_fbrequired").is(":checked");
          vm.$currentFormEditor.attr("fbrequired", fbrequired);

          let invisible = $modal.find(".modal-body #txt_fbinvisible").is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbplaceholder = $modal.find(".modal-body #txt_fbplaceholder").val();
          vm.$currentFormEditor.attr("fbplaceholder", fbplaceholder);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fblabelposition = $modal.find(".modal-body #txt_fblabelposition option:selected").val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal.find(".modal-body #txt_fbdefaultvalue").val();
          vm.$currentFormEditor.attr("value", fbdefaultvalue);

          let fbminlength = $modal.find(".modal-body #txt_fbminlength").val();
          vm.$currentFormEditor.attr('fbminlength', fbminlength);

          //let fbmaxlength = $modal.find(".modal-body #txt_fbdefaultvalue").attr("maxlength");
          let fbmaxlength = $modal.find(".modal-body #txt_fbmaxlength").val();
          vm.$currentFormEditor.attr("fbmaxlength", fbmaxlength);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");

          let fbtype = $modal.find(".modal-body #txt_fbtype").children().val();
          vm.$currentFormEditor.attr("fbtype", fbtype);

          let fbtextcase = $modal.find(".modal-body #txt_fbtextcase").children().val();
          vm.$currentFormEditor.attr("fbtextcase", fbtextcase);

          let fbinputmask = $('#txt_fbinputmask').val();
          if(fbinputmask){
            vm.$currentFormEditor.attr("fbinputmask", "'mask':'" + fbinputmask + "'");
          }

          if (fbtype) {
            var options = $modal.find(".modal-body #txt_fbspecificcolumn").children().children();
            let result = [];
            result.push("'" + $modal.find(".modal-body #txt_fbmodelbuilder").val() + "'");
            $.each(options, function(key, value) {
              let check = $(value).find("input").is(":checked");
              if (check == true) {
                result.push("'" +$(value).find("input").val() +"'");
              }
            });

            result.length > 0 ? vm.$currentFormEditor.attr("fbtypedetail", "[" + result + "]") : vm.$currentFormEditor.attr("fbtypedetail", "");
          } else {
            vm.$currentFormEditor.attr("fbtypedetail", null);
          }

          if (vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor.parents(".fbDetailTable").parents(".fbrow").first().find("formeditor").first().attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr("column_name", column.column_name);
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr("mb_form_table_id", vm.modelBuilder.mainTable.property.id);
            vm.$currentFormEditor.attr("mb_form_table_type", vm.modelBuilder.mainTable.property.type);

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }
        } else if (modelType == "textArea") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal
            .find(".modal-body #txt_fbhidelabel")
            .is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

 let submitcanchange = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);
          
        

          let required = $modal
            .find(".modal-body #txt_fbrequired")
            .is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal
            .find(".modal-body #txt_fbinvisible")
            .is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let placeholder = $modal.find(".modal-body #txt_fbplaceholder").val();
          vm.$currentFormEditor.attr("fbplaceholder", placeholder);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fblabelposition = $modal
            .find(".modal-body #txt_fblabelposition option:selected")
            .val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal
            .find(".modal-body #txt_fbdefaultvalue")
            .val();
          vm.$currentFormEditor.attr("value", fbdefaultvalue);

          let fbrows = $modal.find(".modal-body #txt_fbrows").val();
          vm.$currentFormEditor.attr("fbrows", fbrows);

          let fbmaxlength = $modal
            .find(".modal-body #txt_fbdefaultvalue")
            .attr("maxlength");
          vm.$currentFormEditor.attr("fbmaxlength", fbmaxlength);

          let fbinputmask = "'mask':'" + $('#txt_fbinputmask').val() + "'";
          vm.$currentFormEditor.attr("fbinputmask", fbinputmask);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");

          if (
            vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0
          ) {

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor
                .parents(".fbDetailTable")
                .parents(".fbrow")
                .first()
                .find("formeditor")
                .first()
                .attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr(
              "mb_form_table_id",
              vm.modelBuilder.mainTable.property.id
            );
            vm.$currentFormEditor.attr(
              "mb_form_table_type",
              vm.modelBuilder.mainTable.property.type
            );

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }
        } else if (modelType == "dateInput" || modelType == "dateTimeInput") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal
            .find(".modal-body #txt_fbhidelabel")
            .is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

          let submitcanchange = $modal
            .find(".modal-body #txt_fbsubmitcanchange")
            .is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

          let fbsupportmultiplelanguages = $modal
            .find(".modal-body #txt_fbsupportmultiplelanguages")
            .is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let required = $modal
            .find(".modal-body #txt_fbrequired")
            .is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal
            .find(".modal-body #txt_fbinvisible")
            .is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fblabelposition = $modal
            .find(".modal-body #txt_fblabelposition option:selected")
            .val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal
            .find(".modal-body #txt_fbdefaultvalue")
            .val();
          vm.$currentFormEditor.attr("value", fbdefaultvalue);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");

          let fbtype = $modal
            .find(".modal-body #txt_fbtype")
            .children()
            .val();
          vm.$currentFormEditor.attr("fbtype", fbtype);

          if (fbtype) {
            var options = $modal
              .find(".modal-body #txt_fbspecificcolumn")
              .children()
              .children();
            let result = [];
            result.push(
              "'" + $modal.find(".modal-body #txt_fbmodelbuilder").val() + "'"
            );
            $.each(options, function(key, value) {
              let check = $(value)
                .find("input")
                .is(":checked");
              if (check == true) {
                result.push(
                  "'" +
                    $(value)
                      .find("input")
                      .val() +
                    "'"
                );
              }
            });

            result.length > 0
              ? vm.$currentFormEditor.attr("fbtypedetail", "[" + result + "]")
              : vm.$currentFormEditor.attr("fbtypedetail", "");
          } else {
            vm.$currentFormEditor.attr("fbtypedetail", null);
          }

          if (vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor
                .parents(".fbDetailTable")
                .parents(".fbrow")
                .first()
                .find("formeditor")
                .first()
                .attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr(
              "mb_form_table_id",
              vm.modelBuilder.mainTable.property.id
            );
            vm.$currentFormEditor.attr(
              "mb_form_table_type",
              vm.modelBuilder.mainTable.property.type
            );

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }
        } else if (modelType == "numberInput") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal.find(".modal-body #txt_fbhidelabel").is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal.find(".modal-body #txt_fbreadonly").is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

          
          let submitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

          let fbsupportmultiplelanguages = $modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let required = $modal.find(".modal-body #txt_fbrequired").is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal.find(".modal-body #txt_fbinvisible").is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fbplaceholder = $modal.find(".modal-body #txt_fbplaceholder").val();
          vm.$currentFormEditor.attr("fbplaceholder", fbplaceholder);

          let fblabelposition = $modal.find(".modal-body #txt_fblabelposition option:selected").val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal.find(".modal-body #txt_fbdefaultvalue").val();
          vm.$currentFormEditor.attr("value", fbdefaultvalue);

          let fbmaxlength = $modal.find(".modal-body #txt_fbdefaultvalue").attr("maxlength");
          vm.$currentFormEditor.attr("fbmaxlength", fbmaxlength);

          let fbdecimalplaces = $modal.find(".modal-body #txt_fbdecimal_places").val();
          vm.$currentFormEditor.attr("fbdecimalplaces", fbdecimalplaces);

          let fbinputmask =  $('#txt_fbinputmask').val();
          
          if(fbinputmask){
            vm.$currentFormEditor.attr("fbinputmask", "'mask':'" + fbinputmask + "'");
          }else{
            vm.$currentFormEditor.attr("fbinputmask", '');
          }

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");

          // For Summarize different column into one field.
          let fbtype = $modal.find(".modal-body #txt_fbtype").children().val();
          vm.$currentFormEditor.attr("fbtype", fbtype);

          if (fbtype) {
            let options = $modal.find(".modal-body #txt_fbspecificcolumn").children().children();
            let result = [];
            result.push("'" + $modal.find(".modal-body #txt_fbmodelbuilder").val() + "'");
            $.each(options, function(key, value) {
              let check = $(value).find("input").is(":checked");
              if (check == true) {
                result.push( "'" + $(value).find("input").val() +"'");
              }
            });
            if(fbtype == 'percentage'){
              result.push("'" + $modal.find('.modal-body #txt_fbpercentage_value').val() + "'");
            }else if(fbtype == 'gst'){
              let options2 = $modal.find(".modal-body #txt_fbspecificcolumn2").children().children();
              $.each(options2, function(key, value) {
              let check = $(value).find("input").is(":checked");
              if (check == true) {
                result.push( "'" + $(value).find("input").val() +"'");
              }
            });
            }else if (fbtype == "difference"){
              result.push("'" + $modal.find('.modal-body #txt_fbdifference_type').val() + "'");
            }else if (fbtype == "multiplication"){
              result.push("'" + $modal.find('.modal-body #txt_fbmultiplication_value').val() + "'");
            }

            result.length > 0 ? vm.$currentFormEditor.attr("fbtypedetail", "[" + result + "]") : vm.$currentFormEditor.attr("fbtypedetail", "");
          } else {
            vm.$currentFormEditor.attr("fbtypedetail", null);
          }

          if (vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0) {
            //components inside the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor
                .parents(".fbDetailTable")
                .parents(".fbrow")
                .first()
                .find("formeditor")
                .first()
                .attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                  }
                });
              }
            });
          } else {
            //components outside the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr("mb_form_table_id",vm.modelBuilder.mainTable.property.id);
            vm.$currentFormEditor.attr("mb_form_table_type",vm.modelBuilder.mainTable.property.type);

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }
        } else if (modelType == "checkBox") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal
            .find(".modal-body #txt_fbhidelabel")
            .is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

          let submitcanchange = $modal
            .find(".modal-body #txt_fbsubmitcanchange")
            .is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

           let fbsupportmultiplelanguages = $modal
            .find(".modal-body #txt_fbsupportmultiplelanguages")
            .is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let required = $modal
            .find(".modal-body #txt_fbrequired")
            .is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal
            .find(".modal-body #txt_fbinvisible")
            .is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          // let fbhelptext = $modal.find('.modal-body #txt_fbhelptext').val()
          // vm.$currentFormEditor.attr('fbhelptext', fbhelptext);

          let fblabelposition = $modal
            .find(".modal-body #txt_fblabelposition option:selected")
            .val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal
            .find("#txt_fbdefaultvalue")
            .is(":checked");
          vm.$currentFormEditor.attr("value", fbdefaultvalue);
          
          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");

          if (
            vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0
          ) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor
                .parents(".fbDetailTable")
                .parents(".fbrow")
                .first()
                .find("formeditor")
                .first()
                .attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr(
              "mb_form_table_id",
              vm.modelBuilder.mainTable.property.id
            );
            vm.$currentFormEditor.attr(
              "mb_form_table_type",
              vm.modelBuilder.mainTable.property.type
            );

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }
        } else if (modelType == "selectBox" || modelType == "checkBoxes") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal.find(".modal-body #txt_fbhidelabel").is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal.find(".modal-body #txt_fbreadonly").is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

           let submitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

          let fbsupportmultiplelanguages = $modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let required = $modal.find(".modal-body #txt_fbrequired").is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal.find(".modal-body #txt_fbinvisible").is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fbplaceholder = $modal.find(".modal-body #txt_fbplaceholder").val();
          vm.$currentFormEditor.attr("fbplaceholder", fbplaceholder);

          let fblabelposition = $modal.find(".modal-body #txt_fblabelposition option:selected").val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal.find(".modal-body #txt_fbdefaultvalue").val();
          vm.$currentFormEditor.attr("value", fbdefaultvalue);

          let fbmaxlength = $modal.find(".modal-body #txt_fbdefaultvalue").attr("maxlength");
          vm.$currentFormEditor.attr("fbmaxlength", fbmaxlength);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");
          vm.$currentFormEditor.empty();

          let fbtype = $modal.find(".modal-body #txt_fbtype").children().val();
          vm.$currentFormEditor.attr("fbtype", fbtype);

          if (fbtype) {
            let options = $modal.find(".modal-body #txt_fbspecificcolumn").children().children();
            let result = [];

            result.push("'" + $modal.find(".modal-body #txt_fbmodelbuilder").val() + "'");
            $.each(options, function(key, value) {
              let check = $(value).find("input").is(":checked");
              if (check == true) {
                result.push( "'" +$(value).find("input").val() + "'");
                if(fbtype == 'postcode'){
                  result.push("'" + $modal.find('.modal-body #txt_fbpostcode_country').val() + "'");
                  
                  let fbcountry = $modal.find(".modal-body #txt_fbpostcode_country").val();
                  vm.$currentFormEditor.attr("fbcountry", fbcountry);
                }
              }
            });

            result.length > 0 ? vm.$currentFormEditor.attr("fbtypedetail", "[" + result + "]") : vm.$currentFormEditor.attr("fbtypedetail", "");
          } else {
            vm.$currentFormEditor.attr("fbtypedetail", null);

            if ($modal.find("#txt_fbselect tr").length - 1 > 0) {
              for (var i = 1; i < $modal.find("#txt_fbselect tr").length; i++) {
                let value = String($modal.find(`#txt_fbselect tr:nth-child(${i})`).find(".selectvalue").val()).replace(/&#32;/g, " ");
                let label = String($modal.find(`#txt_fbselect tr:nth-child(${i})`).find(".selectlabel").val()).replace(/&#32;/g, " ");
                let tag = `<option fbselectlabel='${label}' fbselectvalue='${value}'></option>`;
                vm.$currentFormEditor.append(tag);
              }
              $modal.find(".modal-body #txt_fbselect tbody").empty();
            }
          }

          if (vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor.parents(".fbDetailTable").parents(".fbrow").first().find("formeditor").first().attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr("column_name",column.column_name);
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr("mb_form_table_id",vm.modelBuilder.mainTable.property.id);
            vm.$currentFormEditor.attr("mb_form_table_type",vm.modelBuilder.mainTable.property.type);

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }
        } else if (modelType == "preparerselectbox") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal.find(".modal-body #txt_fbhidelabel").is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal.find(".modal-body #txt_fbreadonly").is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

           let submitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

           let fbsupportmultiplelanguages = $modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let required = $modal.find(".modal-body #txt_fbrequired").is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal.find(".modal-body #txt_fbinvisible").is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fbplaceholder = $modal.find(".modal-body #txt_fbplaceholder").val();
          vm.$currentFormEditor.attr("fbplaceholder", fbplaceholder);

          let fblabelposition = $modal.find(".modal-body #txt_fblabelposition option:selected").val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal.find(".modal-body #txt_fbdefaultvalue").val();
          vm.$currentFormEditor.attr("value", fbdefaultvalue);

          let fbmaxlength = $modal.find(".modal-body #txt_fbdefaultvalue").attr("maxlength");
          vm.$currentFormEditor.attr("fbmaxlength", fbmaxlength);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");
          vm.$currentFormEditor.empty();

  
        } else if (modelType == "radioBox") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal
            .find(".modal-body #txt_fbhidelabel")
            .is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

              let submitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

           let fbsupportmultiplelanguages = $modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let required = $modal
            .find(".modal-body #txt_fbrequired")
            .is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal
            .find(".modal-body #txt_fbinvisible")
            .is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fblabelposition = $modal
            .find(".modal-body #txt_fblabelposition option:selected")
            .val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal
            .find(".modal-body #txt_fbdefaultvalue")
            .val();
          vm.$currentFormEditor.attr("value", fbdefaultvalue);

          let fbmaxlength = $modal
            .find(".modal-body #txt_fbdefaultvalue")
            .attr("maxlength");
          vm.$currentFormEditor.attr("fbmaxlength", fbmaxlength);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");

          if (
            vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0
          ) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor
                .parents(".fbDetailTable")
                .parents(".fbrow")
                .first()
                .find("formeditor")
                .first()
                .attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr(
              "mb_form_table_id",
              vm.modelBuilder.mainTable.property.id
            );
            vm.$currentFormEditor.attr(
              "mb_form_table_type",
              vm.modelBuilder.mainTable.property.type
            );

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }

          if ($modal.find("#txt_fbselect tr").length - 1 > 0) {
            vm.$currentFormEditor.empty();
            for (var i = 1; i < $modal.find("#txt_fbselect tr").length; i++) {
              let value = String(
                $modal
                  .find(`#txt_fbselect tr:nth-child(${i})`)
                  .find(".selectvalue")
                  .val()
              ).replace(/&#32;/g, " ");
              let label = String(
                $modal
                  .find(`#txt_fbselect tr:nth-child(${i})`)
                  .find(".selectlabel")
                  .val()
              ).replace(/&#32;/g, " ");
              let tag = `<option fbselectlabel='${label}' fbselectvalue='${value}'></option>`;
              vm.$currentFormEditor.append(tag);
            }
            $modal.find(".modal-body #txt_fbselect tbody").empty();
          }
        } else if (modelType == "fileUpload") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal
            .find(".modal-body #txt_fbhidelabel")
            .is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

             let submitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

           let fbsupportmultiplelanguages = $modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let required = $modal
            .find(".modal-body #txt_fbrequired")
            .is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal
            .find(".modal-body #txt_fbinvisible")
            .is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");
          vm.$currentFormEditor.attr("fb:isMobile", "isMobile");
          vm.$currentFormEditor.attr("fb:fileresponse", "fileresponse");


           
            let options = $modal.find(".modal-body #txt_fbspecificcolumn").children().children();
            let options2 = $modal.find(".modal-body #txt_fbspecificcolumn2").children().children();
           
            let result = [];

            result.push("'" + $modal.find(".modal-body #txt_fbmodelbuilder").val() + "'");
              
               $.each(options, function(key, value) {
              let check = $(value).find("input").is(":checked");
              if (check == true) {
                result.push( "'" + $(value).find("input").val() +"'");
              }
               });

              
              $.each(options2, function(key, value) {
              let check = $(value).find("input").is(":checked");
              if (check == true) {
                result.push( "'" + $(value).find("input").val() +"'");
              }
               });
 if (result.length > 1) {
            result.length > 1 ? vm.$currentFormEditor.attr("fbtypedetail", "[" + result + "]") : vm.$currentFormEditor.attr("fbtypedetail", "");
          } else {
            vm.$currentFormEditor.attr("fbtypedetail", null);
          }

          if (
            vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0
          ) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor
                .parents(".fbDetailTable")
                .parents(".fbrow")
                .first()
                .find("formeditor")
                .first()
                .attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);
                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;
                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                    //vm.$currentFormEditor.attr(':deleteFileList', column.column_name + '_delete');
                    vm.$currentFormEditor.attr(
                      ":attachmentList",
                      "d.attachmentList"
                    );
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr(
              "mb_form_table_id",
              vm.modelBuilder.mainTable.property.id
            );
            vm.$currentFormEditor.attr(
              "mb_form_table_type",
              vm.modelBuilder.mainTable.property.type
            );

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
                //vm.$currentFormEditor.attr(':deleteFileList', column.column_name + '_delete');
                vm.$currentFormEditor.attr(
                  ":attachmentList",
                  "formData." +
                    vm.modelBuilder.mainTable.property.table_name +
                    ".attachmentList"
                );
              }
            });
          }
        } else if (modelType == "ocrbutton") {
          let label = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", label);

          let hidelabel = $modal
            .find(".modal-body #txt_fbhidelabel")
            .is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", hidelabel);

          let readonly = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", readonly);

             let submitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

          let required = $modal
            .find(".modal-body #txt_fbrequired")
            .is(":checked");
          vm.$currentFormEditor.attr("fbrequired", required);

          let invisible = $modal
            .find(".modal-body #txt_fbinvisible")
            .is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");
          vm.$currentFormEditor.attr("fb:isMobile", "isMobile");
          vm.$currentFormEditor.attr("fb:fileresponse", "fileresponse");


           
            let options = $modal.find(".modal-body #txt_fbspecificcolumn").children().children();
            let options2 = $modal.find(".modal-body #txt_fbspecificcolumn2").children().children();
           
            let result = [];

            result.push("'" + $modal.find(".modal-body #txt_fbmodelbuilder").val() + "'");
              
               $.each(options, function(key, value) {
              let check = $(value).find("input").is(":checked");
              if (check == true) {
                result.push( "'" + $(value).find("input").val() +"'");
              }
               });

              
              $.each(options2, function(key, value) {
              let check = $(value).find("input").is(":checked");
              if (check == true) {
                result.push( "'" + $(value).find("input").val() +"'");
              }
               });
 if (result.length > 1) {
            result.length > 1 ? vm.$currentFormEditor.attr("fbtypedetail", "[" + result + "]") : vm.$currentFormEditor.attr("fbtypedetail", "");
          } else {
            vm.$currentFormEditor.attr("fbtypedetail", null);
          }

          if (
            vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0
          ) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor
                .parents(".fbDetailTable")
                .parents(".fbrow")
                .first()
                .find("formeditor")
                .first()
                .attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);
                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;
                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                    //vm.$currentFormEditor.attr(':deleteFileList', column.column_name + '_delete');
                    vm.$currentFormEditor.attr(
                      ":attachmentList",
                      "d.attachmentList"
                    );
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr(
              "mb_form_table_id",
              vm.modelBuilder.mainTable.property.id
            );
            vm.$currentFormEditor.attr(
              "mb_form_table_type",
              vm.modelBuilder.mainTable.property.type
            );

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
                //vm.$currentFormEditor.attr(':deleteFileList', column.column_name + '_delete');
                vm.$currentFormEditor.attr(
                  ":attachmentList",
                  "formData." +
                    vm.modelBuilder.mainTable.property.table_name +
                    ".attachmentList"
                );
              }
            });
          }
        } else if (modelType == "dayOrHourInput") {
          let fblabel = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", fblabel);

          let fbhidelabel = $modal
            .find(".modal-body #txt_fbhidelabel")
            .is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", fbhidelabel);

          let fbreadonly = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", fbreadonly);

             let submitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

let fbsupportmultiplelanguages = $modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);


          let fbrequired = $modal
            .find(".modal-body #txt_fbrequired")
            .is(":checked");
          vm.$currentFormEditor.attr("fbrequired", fbrequired);

          let invisible = $modal
            .find(".modal-body #txt_fbinvisible")
            .is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbplaceholder = $modal
            .find(".modal-body #txt_fbplaceholder")
            .val();
          vm.$currentFormEditor.attr("fbplaceholder", fbplaceholder);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fblabelposition = $modal
            .find(".modal-body #txt_fblabelposition option:selected")
            .val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          let fbdefaultvalue = $modal
            .find(".modal-body #txt_fbdefaultvalue")
            .val();
          vm.$currentFormEditor.attr("value", fbdefaultvalue);

          let fbmaxlength = $modal
            .find(".modal-body #txt_fbdefaultvalue")
            .attr("maxlength");
          vm.$currentFormEditor.attr("fbmaxlength", fbmaxlength);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");

          let fbtype = $modal
            .find(".modal-body #txt_fbtype")
            .children()
            .val();
          vm.$currentFormEditor.attr("fbtype", fbtype);

          if (fbtype) {
            options = $modal
              .find(".modal-body #txt_fbspecificcolumn")
              .children()
              .children();
            let result = [];
            result.push(
              "'" + $modal.find(".modal-body #txt_fbmodelbuilder").val() + "'"
            );
            $.each(options, function(key, value) {
              let check = $(value)
                .find("input")
                .is(":checked");
              if (check == true) {
                result.push(
                  "'" +
                    $(value)
                      .find("input")
                      .val() +
                    "'"
                );
              }
            });

            result.length > 0
              ? vm.$currentFormEditor.attr("fbtypedetail", "[" + result + "]")
              : vm.$currentFormEditor.attr("fbtypedetail", "");
          } else {
            vm.$currentFormEditor.attr("fbtypedetail", null);
          }

          if (
            vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0
          ) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor.parents(".fbDetailTable").parents(".fbrow").first().find("formeditor").first().attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr("mb_form_table_id",vm.modelBuilder.mainTable.property.id);
            vm.$currentFormEditor.attr(
              "mb_form_table_type",
              vm.modelBuilder.mainTable.property.type
            );

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }
        } else if (modelType == "signature") {
          let fblabel = $modal.find(".modal-body #txt_fblabel").val();
          vm.$currentFormEditor.attr("fblabel", fblabel);

          let fbhidelabel = $modal
            .find(".modal-body #txt_fbhidelabel")
            .is(":checked");
          vm.$currentFormEditor.attr("fbhidelabel", fbhidelabel);

          let fbreadonly = $modal
            .find(".modal-body #txt_fbreadonly")
            .is(":checked");
          vm.$currentFormEditor.attr("fbreadonly", fbreadonly);

             let submitcanchange = $modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked");
          vm.$currentFormEditor.attr("fbsubmitcanchange", submitcanchange);

           let fbsupportmultiplelanguages = $modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked");
          vm.$currentFormEditor.attr("fbsupportmultiplelanguages", fbsupportmultiplelanguages);

          let fbrequired = $modal
            .find(".modal-body #txt_fbrequired")
            .is(":checked");
          vm.$currentFormEditor.attr("fbrequired", fbrequired);

          let invisible = $modal
            .find(".modal-body #txt_fbinvisible")
            .is(":checked");
          vm.$currentFormEditor.attr("fbinvisible", invisible);

          let fbhelptext = $modal.find(".modal-body #txt_fbhelptext").val();
          vm.$currentFormEditor.attr("fbhelptext", fbhelptext);

          let fblabelposition = $modal
            .find(".modal-body #txt_fblabelposition option:selected")
            .val();
          vm.$currentFormEditor.attr("fblabelposition", fblabelposition);

          vm.$currentFormEditor.attr("fb:isEdit", "isEdit");

          vm.$currentFormEditor.attr("fb:approvalEdit", "approvalEdit");
           
          if (
            vm.$currentFormEditor.parents(".fbDetailTable").first().length > 0
          ) {
            //components in the detail table

            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);

            let subTables = vm.modelBuilder.subTables;
            $.each(subTables, function(key, value) {
              let prop = value.property;
              let subtable = vm.$currentFormEditor
                .parents(".fbDetailTable")
                .parents(".fbrow")
                .first()
                .find("formeditor")
                .first()
                .attr("mb_form_table_id");

              if (subtable == prop.id) {
                vm.$currentFormEditor.attr("mb_form_table_id", prop.id);
                vm.$currentFormEditor.attr("mb_form_table_type", prop.type);

                var columns = value.columns;
                $.each(columns, function(key, value) {
                  var column = value;

                  if (model == column.column_name) {
                    vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                    vm.$currentFormEditor.attr(
                      "column_name",
                      column.column_name
                    );
                  }
                });
              }
            });
          } else {
            //components not in the detail table
            let model = $modal.find(".modal-body #txt_fbmodelbuilder").val();
            vm.$currentFormEditor.attr("fbv-model", "formData." + model);
            vm.$currentFormEditor.attr(
              "mb_form_table_id",
              vm.modelBuilder.mainTable.property.id
            );
            vm.$currentFormEditor.attr(
              "mb_form_table_type",
              vm.modelBuilder.mainTable.property.type
            );

            $.each(vm.modelBuilder.mainTable.columns, function(key, value) {
              let column = value;
              if (model === column.column_name) {
                vm.$currentFormEditor.attr("mb_form_column_id", column.id);
                vm.$currentFormEditor.attr("column_name", column.column_name);
              }
            });
          }
        }

        /* Set form builder user interface */
        if ($modal.find(".modal-body #txt_fbhidelabel").is(":checked") && !$view.find(".fbDetailTable").length > 0) { //hide label
          //hide label
          $view.find(".col-form-label").first().css("visibility", "hidden");
          $view.find(".col-check-label").first().css("visibility", "hidden");          
        } else if (!$modal.find(".modal-body #txt_fbhidelabel").is(":checked") && !$view.find(".fbDetailTable").length > 0) {
          $view.find(".col-form-label").first().css("visibility", "visible ");
          $view.find(".col-check-label").first().css("visibility", "visible ");
        }

        $view.find(".userinput").val($modal.find(".modal-body #txt_fbdefaultvalue").val()); //value
        $view.find(".userinput").attr('minlength', $modal.find('.modal-body #txt_fbminlength').val()); //min length
        $view.find('.userinput').attr('maxlength', $modal.find('.modal-body #txt_fbmaxlength').val()); //max length

        if ($modal.find(".modal-body #txt_fbreadonly").is(":checked")) { //readonly
          //readonly
          $view.find(".userinput").attr("readonly", true);
        } else {
          $view.find(".userinput").attr("readonly", false);
        }

        if ($modal.find(".modal-body #txt_fbsubmitcanchange").is(":checked")) { 
          $view.find(".userinput").attr("submitcanchange", true);
        } else {
          $view.find(".userinput").attr("submitcanchange", false);
        }

         if ($modal.find(".modal-body #txt_fbsupportmultiplelanguages").is(":checked")) { 
          $view.find(".userinput").attr("fbsupportmultiplelanguages", true);
        } else {
          $view.find(".userinput").attr("fbsupportmultiplelanguages", false);
        }

        $view.find(".userinput").attr("placeholder",$modal.find(".modal-body #txt_fbplaceholder").val()); //placeholder

        $view.find(".description").html($modal.find(".modal-body #txt_fbhelptext").val()); //description

        $view.children().removeClass("text-center"); //label position
        $view.find(".fbinput").removeClass("d-flex flex-row-reverse");

        if(modelType != "signature"){
          switch ($modal.find(".modal-body #txt_fblabelposition").val()) {
            case "top":
              $view.find(".fbinput").children().removeClass("col-12").addClass("col-12");
              break;
            case "left":
              $view.find(".fbinput").children().first().removeClass("col-12").addClass("col-2");
              $view.find(".fbinput .userinput").parent().removeClass("col-12").addClass("col-10");
              break;
            case "right":
              $view.find(".fbinput").addClass("d-flex flex-row-reverse");
              $view.find(".fbinput").children().first().removeClass("col-12").addClass("col-2");
              $view.find(".fbinput .userinput").parent().removeClass("col-12").addClass("col-10");
              $view.find(".description").addClass("col-12");
              break;
            case "center":
              $view.find(".fbinput").children().removeClass("col-12").removeClass("col-2").addClass("col-12");
              $view.children().first().addClass("text-center");
              $view.find(".description").addClass("col-12").addClass("text-left");
              break;
          }
        }else{
          console.log('reached here');
          switch($modal.find(".modal-body #txt_fblabelposition").val()){
            case "top":
              $view.find(".fbinput").removeClass("col-sm-2").addClass("col-sm-12");
              $view.find(".form-check").removeClass("col-sm-10").addClass("col-sm-12");
              break;
            case "left":
              $view.find(".fbinput .col-form-label").addClass("col-sm-2");
              $view.find(".fbinput .form-check").removeClass("col-sm-12 ").addClass("col-sm-10");
              break;
            case "right":
              $view.find(".fbinput").addClass("d-flex flex-row-reverse");
              $view.find(".fbinput .form-check").removeClass("col-sm-12 ").addClass("col-sm-10");
              $view.find(".description").addClass("col-12").addClass("text-left");

              break;
            case "center":
              $view.find(".fbinput .col-form-label").addClass("text-center");
              $view.find(".description").addClass("col-12").addClass("text-left");
              break;
          }
        }

        if($modal.find(".modal-body #txt_fbinvisible").is(":checked")){ //invisible vuejs
          $view.hide();
        }else{
          $view.show();
        }

        if (modelType == "detailTable") { //label + required
          $view.find(".detailTableLabel").text($modal.find(".modal-body #txt_fblabel").val());

          if ($modal.find(".modal-body #txt_fbhidelabel").is(":checked")) {
            $view.find(".detailTableLabel").first().css("visibility", "hidden");
          } else {
            $view.find(".detailTableLabel").first().css("visibility", "visible ");
          }
        } else if (modelType == "selectBox") {
          $view.find(".form-check-label").text($modal.find(".modal-body #txt_fblabel").val());

          let $select = $view.find("select");
          $select.empty();
          for (let i = 1; i <= vm.$currentFormEditor.children().length; i++) {
            let value = vm.$currentFormEditor.find(`option:nth-child(${i})`).attr("fbselectvalue");
            let label = vm.$currentFormEditor.find(`option:nth-child(${i})`).attr("fbselectlabel");
            let tag = `<option value='${value}'>${label}</option>`;
            $select.append(tag);
          }

          $select.val($modal.find(".modal-body #txt_fbdefaultvalue").val());

          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            $temp = $view.find(".col-form-label").html();
            $view.find(".col-form-label").html("<i style='color: red;'>*</i> " + $temp);
          } else {
            $temp = $view.find(".col-form-label").html(vm.$currentFormEditor.attr("fblabel"));
          }

          $temp = $view.find(".col-form-label").first().html(vm.$currentFormEditor.attr("fblabel"));
          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            //required
            $temp = $view.find(".col-form-label").first().html();
            $view.find(".col-form-label").first().html("<i style='color: red;'>*</i> " + $temp);
          }
        } else if (modelType == "radioBox") {
          let $select = $view.find(".form-group");
          $select.empty();
          for (let i = 1; i <= vm.$currentFormEditor.children().length; i++) {
            let value = vm.$currentFormEditor.find(`option:nth-child(${i})`).attr("fbselectvalue");
            let label = vm.$currentFormEditor.find(`option:nth-child(${i})`).attr("fbselectlabel");
            let tag = `
              <div class="form-check">
              <input class="form-check-input" type="radio" name="${$modal
                .find(".modal-body #txt_fbmodelbuilder")
                .val()}" value="${value}">
              <label class="form-check-label">${label}</label>
              </div>`;
            $select.append(tag);
          }

          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            $temp = $("#txt_fblabel").val();
            $view.find(".col-form-label").html("<i style='color: red;'>*</i> " + $temp);
          } else {
            $view.find(".col-form-label").html($("#txt_fblabel").val());
          }

          $temp = $view.find(".col-form-label").first().html(vm.$currentFormEditor.attr("fblabel"));
          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            //required
            $temp = $view.find(".col-form-label").first().html();
            $view.find(".col-form-label").first().html("<i style='color: red;'>*</i> " + $temp);
          }

          let readonly = vm.$currentFormEditor.attr("fbreadonly");
          if (readonly != null && readonly != undefined && readonly != "") {
            $view.find("input").attr("disabled", true);
          }
        } else if (modelType == "checkBox") {
          $view.find(".form-check-label").text($modal.find(".modal-body #txt_fblabel").val());

          if ($modal.find(".modal-body #txt_fbdefaultvalue").is(":checked")) {
            $view.find(".userinput").attr("checked", true);
          } else {
            $view.find(".userinput").attr("checked", false);
          }

          $temp = $view.find(".form-check-label").first().html(vm.$currentFormEditor.attr("fblabel"));
          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            //required
            $temp = $view.find(".form-check-label").first().html();
            $view.find(".form-check-label").first().html("<i style='color: red;'>*</i> " + $temp);
          }
        } else if (modelType == "textArea") {
          $temp = $view.find(".col-form-label").first().html(vm.$currentFormEditor.attr("fblabel"));
          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            //required
            $temp = $view.find(".col-form-label").first().html();
            $view.find(".col-form-label").first().html("<i style='color: red;'>*</i> " + $temp);
          }
          $view.find("textarea").attr("rows", $modal.find(".modal-body #txt_fbrows").val());
          $view.find("textarea").css("height",12 * $modal.find(".modal-body #txt_fbrows").val() || 15);
        } else if (modelType == "checkBoxes"){
          let $select = $view.find(".form-group");
          $select.empty();
          for (let i = 1; i <= vm.$currentFormEditor.children().length; i++) {
            let value = vm.$currentFormEditor.find(`option:nth-child(${i})`).attr("fbselectvalue");
            let label = vm.$currentFormEditor.find(`option:nth-child(${i})`).attr("fbselectlabel");
            let tag = `
              <div class="form-check">
              <input class="form-check-input" type="checkbox" name="${$modal.find(".modal-body #txt_fbmodelbuilder").val()}" value="${value}">
              <label class="form-check-label">${label}</label>
              </div>`;
            $select.append(tag);
          }

          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            $temp = $("#txt_fblabel").val();
            $view.find(".col-form-label").html("<i style='color: red;'>*</i> " + $temp);
          } else {
            $view.find(".col-form-label").html($("#txt_fblabel").val());
          }

          $temp = $view.find(".col-form-label").first().html(vm.$currentFormEditor.attr("fblabel"));
          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            //required
            $temp = $view.find(".col-form-label").first().html();
            $view.find(".col-form-label").first().html("<i style='color: red;'>*</i> " + $temp);
          }

          let readonly = vm.$currentFormEditor.attr("fbreadonly");
          if (readonly) {
            $view.find("input").attr("disabled", true);
          }
        } else if (modelType == 'signature'){
          $view.find(".col-form-label").text($modal.find(".modal-body #txt_fblabel").val());

          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            //required
            $temp = $view.find(".col-form-label").first().html();
            $view.find(".col-form-label").first().html("<i style='color: red;'>*</i> " + $temp);
          }

        }else {
          var $temp = $view.find(".col-form-label").first().html(vm.$currentFormEditor.attr("fblabel"));  
          if ($modal.find(".modal-body #txt_fbrequired").is(":checked")) {
            //required
            $temp = $view.find(".col-form-label").first().html();
            $view.find(".col-form-label").first().html("<i style='color: red;'>*</i> " + $temp);
          }
        }
      });
    },
    addSelectValue() {
      $("#addValue").click(function(e) {
        var $button = $(e.currentTarget);
        var $table = $button.siblings().find("tbody");
        var maxlength = $(".modal-body #txt_fbdefaultvalue").attr("maxlength");
        var newRow = `
        <tr><td><input type="text" placeholder="Label" class="form-control input-sm selectlabel"></td>
        <td><input type="text" placeholder="Value (${maxlength})" class="form-control input-sm selectvalue" maxlength="${maxlength}"></td>
        <td><button class="btn btn-danger delete"><i class="fas fa-minus-circle icon-white"></i></button></td></tr>`;

        $table.append(newRow);
        $("#propertyModel").modal("handleUpdate");
        //Delete select box value
        $("td")
          .find("button")
          .on("click", function(e) {
            $button = $(e.currentTarget);
            var $targetRow = $button.parents("tr").first();
            $targetRow.remove();
          });

        window.scroll({
          bottom: -100,
          behavior: "smooth"
        });
      });
    },
    setComponents() {
      $(".components").append(
        `
              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm">
                  <i class="fas fa-minus-circle icon-white"></i>Remove
                </a>
                <span class="drag btn btn-info btn-sm">
                  <i class="fas fa-arrows-alt"></i>Drag
                </span>
                <div class="preview col-sm-8">${helper.getWord('Panel with Header')}</div>
                <div class="view">
                  <div class="card fbPanel">
                    <div class="card-header noDrag">
                      <h4 class contenteditable="plaintext-only">Header label</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12 column"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="detailTable"><i class="fas fa-wrench" modelType="detailTable" ></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" hidden v-for=""></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('DetailTable')}
                </div>
                <div class="view">
                    <div class="card fbDetailTable" >
                      <div fbv-for="" class=" cardDetail">
                        <div class="card-header">
                          <div class="container-fluid pl-0 noDrag">
                            <div class="row noshow">
                              <div class="col-auto pl-0">
                                <a href="javascript:void(0)" fbv-on:click="removeDetailClick($event,i)"><i class="fas fa-minus-circle"
                                    style="font-size: 24px;"></i></a>
                              </div>
                              <div class="col-auto detailTableLabel">Default Label</div>
                            </div>
                          </div>
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-12 column">
                          </div>
                        </div>
                        <div class="description">

                        </div>
                        </div>
                      </div>
                      <button type="button" class="btn btn-info btn-block" fbv-on:click="addDetailClick" fbv-if="isEdit"><i class="fas fa-plus-circle" aria-hidden="true"></i>Add Detail</button>

                    </div>
                </div>
              </div>
              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm">
                  <i class="fas fa-minus-circle icon-white"></i>Remove
                </a>
                <span class="drag btn btn-info btn-sm">
                  <i class="fas fa-arrows-alt"></i>Drag
                </span>
                <span class="configuration">
                  <button
                    type="button"
                    class="btn btn-mini btn-secondary"
                    data-toggle="modal"
                    data-target="#propertyModal"
                    modelType="textInput"
                  >
                    <i class="fas fa-wrench" modelType="textInput"></i>${helper.getWord('Properties')}
                  </button>
                  <formeditor fblabel="Default Label" fbv-model hidden></formeditor>
                </span>
                <div class="preview col-sm-8">${helper.getWord('Text Input')}</div>
                <div class="view">
                  <div class="row fbinput textinput" fbv-if="fb.edit">
                    <label class="noDrag col-form-label col-12">Default Label</label>
                    <div class="col-12">
                      <input type="text" class="form-control netGroup noDrag userinput" />
                    </div>
                    <div class="description"></div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbtextbox class="col-sm-12" fblabel="Default Label" />
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="textArea"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Text Area')}
                </div>
                <div class="view">
                  <div class="row fbinput textareainput" fbv-if="fb.edit">
                    <label class="noDrag col-form-label col-12">Default Label</label>

                      <div class="form-group col-12">
                        <textarea class="userinput form-control noDrag"></textarea>
                      </div>

                    <div class="description">

                    </div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbtextarea class="col-sm-12" fblabel="Default Label"/>
                  </div>

                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="dateInput"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Date Input')}
                </div>
                <div class="view">
                  <div class="row fbinput dateinput" fbv-if="fb.edit">
                    <label class="noDrag col-form-label col-12">Default Label</label>
                    <div class="col-12">
                      <input type="date" class="form-control netGroup noDrag datepicker userinput">
                    </div>
                    <div class="description">

                    </div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbdatebox2 class="col-sm-12" fblabel="Default Label"/>
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="dateTimeInput"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Date Time Input')}
                </div>
                <div class="view">
                  <div class="row fbinput datetimeinput" fbv-if="fb.edit">
                    <label class="noDrag col-form-label col-12">Default Label</label>
                    <div class="col-12">
                      <input type="datetime-local" class="form-control netGroup noDrag datepicker userinput">
                    </div>
                    <div class="description">

                    </div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbdatetimebox class="col-sm-12" fblabel="Default Label"/>
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="numberInput"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Number Input')}
                </div>
                <div class="view">
                  <div class="row fbinput numberinput" fbv-if="fb.edit">
                    <label class="noDrag col-form-label col-12">Defautl Label</label>
                    <div class="col-12">
                      <input type="number" class="form-control netGroup noDrag datepicker userinput" step="0.01">
                    </div>
                    <div class="description">

                    </div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbnumberbox class="col-sm-12" fblabel="Default Label"/>
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="selectBox"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Selectbox')}
                </div>
                <div class="view">
                  <div class="row fbinput select" fbv-if="fb.edit">
                    <label class="noDrag col-form-label col-12">Default Label</label>
                    <div class="col-12">
                      <div class="form-group userinput">
                        <select class="form-control">

                        </select>
                      </div>
                    </div>
                    <div class="description">

                    </div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbselectbox class="col-sm-12" fblabel="Default Label"/>
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="radioBox"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Radiobutton')}
                </div>
                <div class="view">
                  <div class="row fbinput radio" fbv-if="fb.edit">
                    <label class="noDrag col-form-label col-12">Default Label</label>
                    <div class="col-12">
                      <div class="form-group">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="radio" value="option1">
                          <label class="form-check-label">
                            Default radio 1
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="description">

                    </div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbradiobox class="col-sm-12" fblabel="Default Label"/>
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="checkBox"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Check Box')}
                </div>
                <div class="view">
                  <div class="row fbinput checkbox" fbv-if="fb.edit">
                    <!-- <label class="col-form-label noDrag col-sm-2">Default Label</label> -->
                    <div class="form-check col-sm-12">
                      <input type="checkbox" class="form-check-input userinput">
                      <label class="form-check-label noDrag description">Default Label</label>
                    </div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbcheckBox class="col-sm-12" fblabel="Default Label"/>
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="fileUpload"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('File Upload')}
                </div>
                <div class="view">
                  <div class="row fbinput fileupload" fbv-if="fb.edit">
                      <label class="col-form-label noDrag col-sm-11">Default Label</label>
                    <div class="col-12">
                      <div class="form-check col-sm-12">
                        <form action="/file-upload" class="dropzone dz-clickable">
                          <div class="dz-default dz-message">Drag files here to upload</div>
                        </form>
                      </div>
                      <div class="col-12">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">Original Name</th>
                              <th scope="col">Remove</th>
                              <th scope="col">Download</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr >
                              <td></td>
                              <td><button class="btn btn-danger btn-block" >Remove</button></td>
                              <td><button class="btn btn-info btn-block" >Download</button></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbfileupload class="col-sm-12" fblabel="Default Label"/>
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="signature"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" fbv-model="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Signature')}
                </div>
                <div class="view">
                  <div class="row fbinput signature" fbv-if="fb.edit">
                    <label class="col-form-label noDrag col-sm-2">Default Label</label>
                    <div class="form-check col-sm-12">
                      <div class='js-signature userinput' style="width: auto; height: 100px;"></div>
                      <p><button id="clearBtn" class="btn btn-default">Clear Canvas</button></p>
                    </div>
                    <div class="description"></div>
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbsignature class="col-sm-12" fblabel="Default Label"/>
                  </div>
                </div>
              </div>

              <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary invisible" data-toggle="modal"
                    data-target="#propertyModal" modelType="recaptcha"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Default Label" modelType="recaptcha" fb:isEdit="isEdit" fb:approvalEdit="approvalEdit" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('reCAPTCHA')}
                </div>
                <div class="view">
                  <div class="row fbinput recaptcha" fbv-if="fb.edit">
                    <img src=${this.recaptcha_image} style="height: 100px;">
                  </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                    <fbrecaptcha fblabel="reCAPTCHA"/>
                  </div>
                </div>
              </div>
                <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                  <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="ocrbutton"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor modelType="ocrbutton" fb:ismobile="isMobile" fb:isedit="isEdit" fb:fileresponse="fileresponse" fb:attachmentlist="d.attachmentlist" fb:approvaledit="approvalEdit" fb:index="i??null" fb:fbtypedetail="" fbv-on:ocrfunction="" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                 ${helper.getWord('OCR Button')}
                </div>
                <div class="view">
                    <div class="btn btn-info btn-sm" fbv-if="fb.edit">
                    <span>OCR</span>
                      </div>
                  <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                     <fbocrbutton fb:ismobile="isMobile" fb:isedit="isEdit" fb:fileresponse="fileresponse" fb:approvaledit="approvalEdit" fb:index="i??null" fb:fbtypedetail="" fbv-on:ocrfunction="" />
                  </div>
                </div>
              </div>
            <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                  <span class="configuration">
                
                  <formeditor modelType="label" fb:ismobile="isMobile" fb:isedit="isEdit" fb:fileresponse="fileresponse" fb:attachmentlist="d.attachmentlist" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Label')}
                </div>
                <div class="view">
                    <div class="card-header noDrag">
                      <div contenteditable="plaintext-only">Label</div>
                    </div>
                </div>
              </div>



               <div class="fbrow ui-draggable">
                <a href="#close" class="remove btn btn-danger btn-sm"><i
                    class="fas fa-minus-circle icon-white"></i>Remove</a>
                <span class="drag btn btn-info btn-sm"><i class="fas fa-arrows-alt"></i>Drag</span>
                <span class="configuration">
                  <button type="button" class="btn btn-mini btn-secondary" data-toggle="modal"
                    data-target="#propertyModal" modelType="preparerselectbox"><i class="fas fa-wrench"></i>${helper.getWord('Properties')}</button>
                  <formeditor fblabel="Preparer Name" fb:updatepreparerid="onUpdatePreparerID" 
                fb:fboptions="[{ id:selectPreparerID , text: preparer_full_name}]" 
                fb:ajaxurl="'/api/userBuildForm/getPreparerUser'" 
                fbsubmitcanchange="false"
                fbrequired="true"
                fblabelposition="top"
                fbv-model="selectPreparerID" fblabel="Preparer Name" fb:isedit="isEdit" fb:approvaledit="approvalEdit" hidden></formeditor>
                </span>
                <div class="preview col-sm-8">
                  ${helper.getWord('Preparer Select')}
                </div>
                <div class="view">
                  <div class="row fbinput select" fbv-if="fb.edit">
                    <label class="noDrag col-form-label col-12">Preparer Name</label>
                    <div class="col-12">
                      <div class="form-group userinput">
                        <select class="form-control">

                        </select>
                      </div>
                    </div>
                    <div class="description">

                    </div>
                  </div>
                <div class="fbResult row" fbv-if="fb.edit == false" hidden>
                <fbpreparerselectbox class="col-sm-12"
                fb:updatepreparerid="onUpdatePreparerID" 
                fbrequired="true"
                fbsubmitcanchange="false"
                fb:fboptions="[{ id:selectPreparerID , text: preparer_full_name}]" 
                fb:ajaxurl="'/api/userBuildForm/getPreparerUser'" 
                fb:createuser="createUserID"
                fbv-model="selectPreparerID" fblabel="Preparer Name" fb:isedit="isEdit" fb:approvaledit="approvalEdit"
                fblabel="Preparer Name"/>
                </div>
              </div>
        `
      );
    },
    toggleFbType(){
      var vm  = this;
      /* fbtype Changing*/
      $('.modal-body #txt_fbtype').children().change(function () {
        $('.modal-body #txt_fbspecificcolumn').show();
        $('.modal-body #txt_fbspecificcolumn').prev().show();
        $('#txt_fbspecificcolumn').find('.form-group').empty();
        $('.modal-body #txt_fbspecificcolumn2').hide();
        $('.modal-body #txt_fbspecificcolumn2').prev().hide();
        $('#txt_fbspecificcolumn2').empty();

        if ($(this).val() == 'amount') {
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = $('.modal-body #txt_fbmodelbuilder').val();

          $.each(mainTable.columns, function (key, column) {
            let value = mainTable.property.table_name + '.' + column.column_name;

            if (model != value && (column.datatype == 'decimal' || column.datatype == 'int')) {
              let option = `
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" value="${value}">
                <label class="custom-control-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
              </div>
              `;
              $('#txt_fbspecificcolumn').find('.form-group').append(option);
            }
          });
          $('#txt_fbspecificcolumn').find('.form-group').append('<hr>');
          $.each(subTables, function (key, subtable) {
            $.each(subtable.columns, function (key, column) {
              let value = subtable.property.table_name + '.' + column.column_name;

              if (model != value && (column.datatype == 'decimal' || column.datatype == 'int')) {
                let option = `
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" value="${value}">
                  <label class="custom-control-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                $('#txt_fbspecificcolumn').find('.form-group').append(option);
              }
            });

          });

          let options = $('.modal-body #txt_fbspecificcolumn').children().children();
          if (vm.$currentFormEditor.attr('fbtypedetail')) {
            let checked = vm.$currentFormEditor.attr('fbtypedetail');
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, '').split(',');
            }
            $.each(checked, function (key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function (key, option) {
              if (checked.includes($(option).find('input').val())) {
                $(option).find('input').prop('checked', true);
              }
            });
          }

        } else if ($(this).val() == 'count') {
          let mainTable = vm.modelBuilder.mainTable;
          let subTables = vm.modelBuilder.subTables;

          $.each(subTables, function (key, subtable) {
            let option = `
            <div class="form-check">
              <input class="form-check-input" type="radio" value="${subtable.property.table_name}">
              <label class="form-check-label">${subtable.property.name}</label>
            </div>`;
            $('#txt_fbspecificcolumn').find('.form-group').append(option);
          });
          if(subTables.length == 0){
            $('.modal-body #txt_fbspecificcolumn .form-group').html("<div class='form-group'>There is no sub table in this form</div>");
          }

        } else if ($(this).val() == 'difference'){
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = $('.modal-body #txt_fbmodelbuilder').val();
          $('#txt_fbspecificcolumn2').show();
          $('#txt_fbspecificcolumn2').prev().show();
          let fbtypedetail = vm.$currentFormEditor.attr("fbtypedetail");
          let difference_type = "";
          if(fbtypedetail){
            difference_type = fbtypedetail.replace(/'/g , '').slice(1, -1).split(',').pop();
          }

          $.each(mainTable.columns, function (key, column) {
            let value = mainTable.property.table_name + '.' + column.column_name;

            if (model != value && (column.datatype == 'decimal' || column.datatype == 'int')) {
              let option = `
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" value="${value}">
                <label class="custom-control-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
              </div>
              `;
              $('#txt_fbspecificcolumn').find('.form-group').append(option);
            }
          });

          $('#txt_fbspecificcolumn').find('.form-group').append('<hr>');

          $.each(subTables, function (key, subtable) {
            $.each(subtable.columns, function (key, column) {
              let value = subtable.property.table_name + '.' + column.column_name;

              if (model != value && (column.datatype == 'decimal' || column.datatype == 'int')) {
                let option = `
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" value="${value}">
                  <label class="custom-control-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                $('#txt_fbspecificcolumn').find('.form-group').append(option);
              }
            });

          });

          let options = $('.modal-body #txt_fbspecificcolumn').children().children();
          if (vm.$currentFormEditor.attr('fbtypedetail')) {
            let checked = vm.$currentFormEditor.attr('fbtypedetail');
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, '').split(',');
            }
            $.each(checked, function (key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function (key, option) {
              if (checked.includes($(option).find('input').val())) {
                $(option).find('input').prop('checked', true);
              }
            });
          }

          $('#txt_fbspecificcolumn2').prev().html('Difference Type'); //Set Difference Sequencial
          let input_column = `
            <select id="txt_fbdifference_type" class="custom-select">
              <option value=""></option>
              <option value="sequential">Sequential</option>
              <option value="invert">Invert</option>
            </select>
          `;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbdifference_type').val(difference_type);//Load Predefined percentage to the input box 

          
          
        } else if ($(this).val() == 'dateDifference') {
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr('fbv-model');
          
          if(model){
            model = model.split('.').slice(1).join('.');
          }


          $.each(mainTable.columns, function (key, column) {
            let value = mainTable.property.table_name + '.' + column.column_name;
            if (model != value && (column.datatype == 'date' || column.datatype == 'datetime')) {
              let option = `
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" value="${value}">
                <label class="custom-control-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
              </div>
              `;
              $('#txt_fbspecificcolumn').find('.form-group').append(option);
            }
          });
          $('#txt_fbspecificcolumn').find('.form-group').append('<hr>');
          $.each(subTables, function (key, subtable) {
            $.each(subtable.columns, function (key, column) {
              let value = subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == 'date' || column.datatype == 'datetime')) {
                let option = `
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" value="${value}">
                  <label class="custom-control-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                $('#txt_fbspecificcolumn').find('.form-group').append(option);
              }
            });

          });
          let options = $('.modal-body #txt_fbspecificcolumn').children().children();
          if (vm.$currentFormEditor.attr('fbtypedetail')) {
            let checked = vm.$currentFormEditor.attr('fbtypedetail');
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, '').split(',');
            }
            $.each(checked, function (key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function (key, option) {
              if (checked.includes($(option).find('input').val())) {
                $(option).find('input').prop('checked', true);
              }
            });
          }
        } else if ($(this).val() == 'postcode') {
          $('#txt_fbspecificcolumn2').show();
          $('#txt_fbspecificcolumn2').prev().show();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr('fbv-model');
          let fbtypedetail = vm.$currentFormEditor.attr("fbtypedetail");
          let defined_country = "";

          if(model){
            model = model.split('.').slice(1).join('.');
          }

          if(fbtypedetail){
            defined_country = fbtypedetail.replace(/'/g , '').slice(1, -1).split(',')[2];
          }

          $.each(mainTable.columns, function (key, column) { //main table column
            let value = mainTable.property.table_name + '.' + column.column_name;
            if (model != value && (column.datatype == 'nvarchar' || column.datatype == 'int' || column.datatype == 'decimal')) {
              let option = `
              <div class="form-check">
              <input class="form-check-input" type="radio" value="${value}">
              <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
              </div>
              `;
              $('#txt_fbspecificcolumn').find('.form-group').append(option);
            }
          });

          $('#txt_fbspecificcolumn').find('.form-group').append('<hr>');

          $.each(subTables, function (key, subtable) { //sub table column
            $.each(subtable.columns, function (key, column) {
              let value = subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == '"nvarchar"' || column.datatype == 'int' || column.datatype == 'decimal')) {
                let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" value="${value}">
                <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                $('#txt_fbspecificcolumn').find('.form-group').append(option);
              }
            });

          });

          let options = $('.modal-body #txt_fbspecificcolumn').children().children(); //load predefined column
          if (vm.$currentFormEditor.attr('fbtypedetail')) {
            let checked = vm.$currentFormEditor.attr('fbtypedetail');
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, '').split(',');
            }
            $.each(checked, function (key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function (key, option) {
              if (checked.includes($(option).find('input').val())) {
                $(option).find('input').prop('checked', true);
              }
            });
          }

          $('#txt_fbspecificcolumn2').prev().html('Country'); //Set country selection
          let input_column = `
            <select id="txt_fbpostcode_country" class="custom-select">
              <option value=""></option>
              <option value="australia">Australia</option>
              <option value="usa">USA</option>
            </select>
          `;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbpostcode_country').val(defined_country);//Load Predefined percentage to the input box 

        } else if ($(this).val() == 'startFromDate'){
          let subTables = vm.modelBuilder.subTables;
          console.log(subTables);
          let mainTable = vm.modelBuilder.mainTable;
          var model = vm.$currentFormEditor.attr('fbv-model');
          
          if(model){
            model = model.split('.').slice(1).join('.');
          }

          //aware of the data type 'date' and 'datetime'
          $.each(mainTable.columns, function (key, column) { //Load maintable column
            let value = mainTable.property.table_name + '.' + column.column_name;
            if (model != value && (column.datatype == 'date')) {
              let option = `
              <div class="form-check">
              <input class="form-check-input" type="radio" name="datestartfrom" value="${value}">
              <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
              </div>
              `;
              $('#txt_fbspecificcolumn').find('.form-group').append(option);
            }
          });

          $('#txt_fbspecificcolumn').find('.form-group').append('<hr>');
          
          $.each(subTables, function (key, subtable) { //Load subtable column
            $.each(subtable.columns, function (key, column) {
              let value = subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == 'date')) {
                let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="datestartfrom" value="${value}">
                <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                $('#txt_fbspecificcolumn').find('.form-group').append(option);
              }
            });

          });

          let options = $('.modal-body #txt_fbspecificcolumn').children().children(); //Load predefined column
          if (vm.$currentFormEditor.attr('fbtypedetail')) {
            let checked = vm.$currentFormEditor.attr('fbtypedetail');
            
            if(checked){
              checked = checked.slice(1, -1).replace(/'/g, '').split(',');
            }
            $.each(checked, function (key, value) {
              value.slice(1, -1); //remove single quote
            });

            $.each(options, function (key, option) {
              if (checked.includes($(option).find('input').val())) {
                $(option).find('input').prop('checked', true);
              }
            });
          }

          if($("#txt_fbspecificcolumn").find('input').length == 0){
            $("#txt_fbspecificcolumn .form-group").html("<div class='form-group'>There is no date column</div>");
            $("#txt_fbspecificcolumn hr").remove();
          }

        }else if($(this).val() == 'percentage'){
          $('#txt_fbspecificcolumn2').show();
          $('#txt_fbspecificcolumn2').prev().show();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          var fbtypedetail = vm.$currentFormEditor.attr("fbtypedetail");
          var defined_column = "";
          var percentage_value = "";

          if(model){
            model = model.split(".").slice(1).join(".");
          }

          if(fbtypedetail){
            defined_column = fbtypedetail.replace(/'/g , '').slice(1, -1).split(',')[1];
            percentage_value = fbtypedetail.replace(/'/g , '').slice(1, -1).split(',')[2];
          }

          $.each(mainTable.columns, function(key, column) {
            let value = mainTable.property.table_name + "." + column.column_name;
            if (model != value && (column.datatype == '"nvarchar"' || column.datatype == "int" || column.datatype == "decimal")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
              if(value == defined_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
            }
          });

          $.each(subTables, function(key, subtable) {
            $.each(subtable.columns, function(key, column) {
              let value = subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == '"nvarchar"' || column.datatype == "int" || column.datatype == "decimal")) {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
                if(value == defined_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

          $('#txt_fbspecificcolumn2').prev().html('Percentage Value');
          var input_column = `
                  <label class="col-form-label col-12">Percentage</label>
                  <div class="col-sm-12">
                    <input type="number" id="txt_fbpercentage_value" class="form-control" placeholder="10%"/>
                  </div>`;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbpercentage_value').val(percentage_value);//Load Predefined percentage to the input box 

        }else if($(this).val() == 'gst'){
          $('#txt_fbspecificcolumn2').show();
          $('#txt_fbspecificcolumn2').prev().show();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          var fbtypedetail = vm.$currentFormEditor.attr("fbtypedetail");
          var defined_column = "";
          var percentage_value = "";

          if(model){
            model = model.split(".").slice(1).join(".");
          }

          if(fbtypedetail){
            defined_column = fbtypedetail.replace(/'/g , '').slice(1, -1).split(',')[1];
            percentage_value = fbtypedetail.replace(/'/g , '').slice(1, -1).split(',')[2];
          }

       $.each(mainTable.columns, function(key, column) { //Load related maintable column
            let value =mainTable.property.table_name + "." + column.column_name;
            if (model != value &&(column.datatype == "int" || column.datatype == "decimal")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="percentage" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
              if(value == defined_column){
                $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
              }
            }
          });

          $.each(subTables, function(key, subtable) { //Load related subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == "int" || column.datatype == "decimal")) {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" name="percentage" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
                if(value == defined_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

          $('#txt_fbspecificcolumn2').prev().html('Percentage Value by Coulumn'); //Create percentage input box for user define
          var input_column = `<div class="form-group">`;

         $('#txt_fbspecificcolumn2').append(input_column);

          $.each(mainTable.columns, function(key, column) { //Load related maintable column
            let value =mainTable.property.table_name + "." + column.column_name;
            if (model != value &&(column.datatype == "nvarchar")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" name="txt_fbpercentage_value" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
             $("#txt_fbspecificcolumn2").find(".form-group").append(option);
              if(value == percentage_value){
                $("#txt_fbspecificcolumn2").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
              }
            }
          });

          $.each(subTables, function(key, subtable) { //Load related subtable column
            $.each(subtable.columns, function(key, column) {
              let value =subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == "nvarchar")) {
              let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" name="txt_fbpercentage_value" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn2").find(".form-group").append(option);
                if(value == percentage_value){
                  $("#txt_fbspecificcolumn2").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

              input_column=`</div>`;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbpercentage_value').val(percentage_value);
  

        }else if ($(this).val() == 'multiplication'){
           $('#txt_fbspecificcolumn2').show();
          $('#txt_fbspecificcolumn2').prev().show();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = vm.$currentFormEditor.attr("fbv-model");
          var fbtypedetail =  vm.$currentFormEditor.attr("fbtypedetail");
          var defined_column = "";
          var multiplication_value = "";

          if(model){
            model = model.split(".").slice(1).join(".");
          }

          if(fbtypedetail){
            defined_column = fbtypedetail.replace(/'/g , '').slice(1, -1).split(',')[1];
            multiplication_value = fbtypedetail.replace(/'/g , '').slice(1, -1).split(',').pop();
          }

          $.each(mainTable.columns, function(key, column) {
            let value = mainTable.property.table_name + "." + column.column_name;
            if (model != value && (column.datatype == '"nvarchar"' || column.datatype == "int" || column.datatype == "decimal")) {
              let option = `
                <div class="form-check">
                <input class="form-check-input" type="radio" value="${value}">
                <label class="form-check-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
              $("#txt_fbspecificcolumn").find(".form-group").append(option);
              if(value == defined_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
            }
          });

          $.each(subTables, function(key, subtable) {
            $.each(subtable.columns, function(key, column) {
              let value = subtable.property.table_name + "." + column.column_name;

              if (model != value && (column.datatype == '"nvarchar"' || column.datatype == "int" || column.datatype == "decimal")) {
                let option = `
                  <div class="form-check">
                  <input class="form-check-input" type="radio" value="${value}">
                  <label class="form-check-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                  </div>
                  `;
                $("#txt_fbspecificcolumn").find(".form-group").append(option);
                if(value == defined_column){
                  $("#txt_fbspecificcolumn").find(".form-group input").last().prop("checked", true); //Check the checkbox of predefined column
                }
              }
            });
          });

          $('#txt_fbspecificcolumn2').prev().html('Multiplication Value');
          var input_column = `
                  <label class="col-form-label col-12">Multiplication</label>
                  <div class="col-sm-12">
                    <input type="number" id="txt_fbmultiplication_value" class="form-control" placeholder="x10"/>
                  </div>`;
          $('#txt_fbspecificcolumn2').append(input_column);
          $('.modal-body #txt_fbmultiplication_value').val(multiplication_value);//Load Predefined multiplication value to the input box 

        }else {
          $('.modal-body #txt_fbspecificcolumn').hide();
          $('.modal-body #txt_fbspecificcolumn').prev().hide();
          $('.modal-body #txt_fbspecificcolumn2').hide();
          $('.modal-body #txt_fbspecificcolumn2').prev().hide();
          $('#txt_fbspecificcolumn').find('.form-group').empty();
          $('#txt_fbspecificcolumn2').empty();
        }
      });
    },
    setMaximum(){
      var vm = this;
      	/* Set Default Input maximum value when changing model*/
      $('.modal-body #txt_fbmodelbuilder').change(function () {
        $('.modal-body tbody').empty();
        //Set default input maximum value
        if (['textInput', 'numberInput', 'textArea', 'selectBox', 'radioBox'].includes(vm.currentModel)) {	//Only these type have default value
          if (vm.$currentFormEditor.parents('.fbDetailTable').first().length > 0) {	//components in the detail table
            let subTable = vm.modelBuilder.subTables;
            let model = $('.modal-body #txt_fbmodelbuilder').val();

            $.each(subTable, function (key, value) {
              let column = value.columns.find(element => element.column_name == model);

              if (column != undefined && column != null) {
                let maxlength = column.length;
                if (maxlength != null || maxlength != undefined) {
                  $('.modal-body #txt_fbdefaultvalue').attr('maxlength', maxlength);
                  $('.modal-body #txt_fbdefaultvalue').attr('placeholder', `Maximum Length: ${maxlength}`);

                }
              }
            });
          } else {
            let mainTableColumn = vm.modelBuilder.mainTable.columns;
            let model = $('.modal-body #txt_fbmodelbuilder').val();
            let column = mainTableColumn.find(element => element.column_name == model.split('.')[1]);
            if (column != undefined && column != null) {
              let maxlength = column.length;
              if (maxlength != null || maxlength != undefined) {
                console.log(maxlength);
                $('.modal-body #txt_fbdefaultvalue').attr('maxlength', maxlength);
                $('.modal-body #txt_fbdefaultvalue').attr('placeholder', `Maximum Length: ${maxlength}`);
              }
            }
          }
        }

        if (vm.currentModel == 'numberInput' && $('.modal-body #txt_fbtype').children().val() == 'amount') {
          $('#txt_fbspecificcolumn').find('.form-group').empty();
          let subTables = vm.modelBuilder.subTables;
          let mainTable = vm.modelBuilder.mainTable;
          let model = $('.modal-body #txt_fbmodelbuilder').val();

          $.each(mainTable.columns, function (key, column) {
            let value = mainTable.property.table_name + '.' + column.column_name;

            if (model != value && (column.datatype == 'decimal' || column.datatype == 'int')) {
              let option = `
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" value="${value}">
                <label class="custom-control-label">${mainTable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
              </div>
              `;
              $('#txt_fbspecificcolumn').find('.form-group').append(option);
            }
          });
          $('#txt_fbspecificcolumn').find('.form-group').append('<hr>');
          $.each(subTables, function (key, subtable) {
            $.each(subtable.columns, function (key, column) {
              let value = subtable.property.table_name + '.' + column.column_name;

              if (model != value && (column.datatype == 'decimal' || column.datatype == 'int')) {
                let option = `
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" value="${value}">
                  <label class="custom-control-label">${subtable.property.name}: &ensp;&ensp;&ensp;${column.column_name}</label>
                </div>
                `;
                $('#txt_fbspecificcolumn').find('.form-group').append(option);
              }
            });

          });
        }
      });
    }
  }
};
</script>
